import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Slider from "react-slick";
import { Header } from "../Header";
import { Footer } from "../Footer";
import { ReactDialogBox } from "react-js-dialog-box";
import "react-js-dialog-box/dist/index.css";
import "../assets/ohs/admin.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaFilePdf, FaEye } from "react-icons/fa";
import generatePDF from "./PDFscore";
export const Course = () => {
  const [PdfcardImg, setPdfcardImg] = useState("");
  const [scoreCard, setscoreCard] = useState("");
  const [closeBox, setcloseBox] = useState(true);
  const second = useRef();
  const third = useRef();
  const forth = useRef();
  const fifth = useRef();
  const sixth = useRef();
  const seven = useRef();
  const inputRef = useRef();
  const stepSecond = useRef();
  const stepThird = useRef();
  const stepForth = useRef();
  const q1 = useRef();
  const q2 = useRef();
  const q3 = useRef();
  const q4 = useRef();
  const scl_6_1 = useRef(null);
  const scl_6_2 = useRef(null);
  const scl_6_3 = useRef(null);
  const [leftmenu_bar, setleftmenu_bar] = useState(0);
  const [barwidth, setbarwidth] = useState(0);
  const [stq, setstq] = useState(true);
  //Lesson 2 Start
  const stepTwo = useRef();
  const stepTwo_2 = useRef();
  const stepTwo_3 = useRef();
  const stepThree = useRef();
  // Lesson 2 Start
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  //Lesson 1 Start
  const [unicode, setunicode] = useState("");
  const [isCourse, setCourse] = useState("");
  const [activeTab, setactiveTab] = useState(false);
  const [activeTablegal, setactiveTablegal] = useState(false);
  const [activeTabmorel, setactiveTabmorel] = useState(false);
  const [activeTabfinanical, setactiveTabfinanical] = useState(false);

  const [activetab1cont, setactivetab1cont] = useState(true);
  const [activeStepsecond, setactiveStepsecond] = useState(false);
  const [activeStepthird, setactiveStepthird] = useState(false);
  const [activeStepforth, setactiveStepforth] = useState(false);

  const [stepbutton11, setstepbutton11] = useState(false);
  const [stepbutton2, setstepbutton2] = useState(false);
  const [stepbutton3, setstepbutton3] = useState(false);
  const [righticonLess_1, setrighticonLess_1] = useState(false);
  const [strokeDashArray_less1, setStrokeDashArray_less1] = useState("");
  const [isless_1_icon, setisless_1_icon] = useState(false);
  const [stepl_1, setstepl_1] = useState([]);
  const [lesson1, setlesson1] = useState(true);
  const [istruefalse_1, setistruefalse_1] = useState(false);
  // Lesson 1 End

  // Lesson 2 Start
  const [step2active, setstep2active] = useState(false);
  const [step1active, setstep1active] = useState(true);
  const [step3active, setstep3active] = useState(false);
  const [step4active, setstep4active] = useState(false);
  const [step2activeBtn, setstep2activeBtn] = useState(false);
  const [lesson2, setlesson2] = useState(false);
  const [istruefalse_2, setistruefalse_2] = useState(false);
  const [strokeDashArray_less2, setStrokeDashArray_less2] = useState("");
  // Lesson 2 End

  //Lesson 3 Start
  const [step3btn_1, setstep3btn_1] = useState(true);
  const [step3btn_2, setstep3btn_2] = useState(false);
  const [step3btn_3, setstep3btn_3] = useState(false);
  const [step3section2, setstep3section2] = useState(false);
  const [step3section3, setstep3section3] = useState(false);
  const [step3section4, setstep3section4] = useState(false);
  const [istabSection, setistabSection] = useState([]);
  const [newtab, setnewtab] = useState("1");
  const [lesson3, setlesson3] = useState(false);
  const [strokeDashArray_less3, setStrokeDashArray_less3] = useState("");
  const [istruefalse_3, setistruefalse_3] = useState(false);
  //Lesson 3 End

  //Lesson 4 Start
  const [lesson4, setlesson4] = useState(false);
  const [istabreview, setistabreview] = useState([]);
  const [tabsectionView, settabsectionView] = useState("Tab1");
  const [btn4, setbtn4] = useState(false);
  const [strokeDashArray_less4, setStrokeDashArray_less4] = useState("");
  const [istruefalse_4, setistruefalse_4] = useState(false);
  //Lesson 4 End

  //Lesson 5 Start
  const [lesson5, setlesson5] = useState(false);
  const [startQuizm, setstartQuiz] = useState(true);
  const [quizmain_Section, setquizmain_Section] = useState(false);
  const [section5_quiz1, setsection5_quiz1] = useState(true);
  const [section5_quiz2, setsection5_quiz2] = useState(false);
  const [section5_quiz3, setsection5_quiz3] = useState(false);
  const [section5_quiz4, setsection5_quiz4] = useState(false);
  const [issetQuizAns_1, setQuizAns_1] = useState("");
  const [issetQuizAns_1_btn, setQuizAns_1_btn] = useState("");
  const [isfirstquiz, setfirstquiz] = useState("");
  const [worngansQuiz_1, setworngansQuiz_1] = useState(false);
  const [rightansQuiz_1, setrightansQuiz_1] = useState(false);
  const [quizStarted, setQuizStarted] = useState(false);
  const [checkQ_1, setcheckQ_1] = useState("");
  const [firstnext, setfirstnext] = useState(false);
  const [firstsub, setfirstsub] = useState(false);
  const [strokeDashArray_less5, setStrokeDashArray_less5] = useState("");
  const [istruefalse_5, setistruefalse_5] = useState(false);
  const [quiz5_result_section, setquiz5_result_section] = useState(false);
  const [userChooseAns_1, setuserChooseAns_1] = useState("");
  const [finalperc, setfinalperc] = useState("220");
  //2nd Question
  const [worngansQuiz_2, setworngansQuiz_2] = useState(false);
  const [rightansQuiz_2, setrightansQuiz_2] = useState(false);
  const [secondsub, setsecondsub] = useState(false);
  const [secondnext, setsecondnext] = useState(false);
  const [checkQ_2, setcheckQ_2] = useState("");
  const [issetQuizAns_2_btn, setQuizAns_2_btn] = useState("");
  const [issecondquiz, setissecondquiz] = useState("");
  const [userChooseAns_2, setuserChooseAns_2] = useState("");
  //2nd Question

  //3rd Question
  const [userChooseAns_3, setuserChooseAns_3] = useState("");
  const [checkQ_3, setcheckQ_3] = useState("");
  const [isthirdquiz, setisthirdquiz] = useState("");
  const [issetQuizAns_3_btn, setQuizAns_3_btn] = useState("");
  const [worngansQuiz_3, setworngansQuiz_3] = useState(false);
  const [rightansQuiz_3, setrightansQuiz_3] = useState(false);
  const [thirdsub, setthirdsub] = useState(false);
  const [thirdnext, setthirdnext] = useState(false);
  //3rd Question

  //4th Question
  const [userChooseAns_4, setuserChooseAns_4] = useState("");
  const [isforthquiz, setisforthquiz] = useState("");
  const [rightansQuiz_4, setrightansQuiz_4] = useState(false);
  const [forthsub, setforthsub] = useState(false);
  const [forthnext, setforthnext] = useState(false);
  const [worngansQuiz_4, setworngansQuiz_4] = useState(false);
  const [checkQ_4, setcheckQ_4] = useState("");
  const [issetQuizAns_4_btn, setQuizAns_4_btn] = useState("");
  //4th Question
  const [isresult, setisresult] = useState("");
  const [stroke_5, setstroke_5] = useState("#F50057");
  //Lesson 5 End

  //Lesson 6 Start
  const [isFlipped6, setisFlipped6] = useState(false);
  const [isFlipped6_1, setisFlipped6_1] = useState(false);
  const [istab_6, setistab_6] = useState([]);
  const [istruefalse_6, setistruefalse_6] = useState(false);
  const [strokeDashArray_less6, setstrokeDashArray_less6] = useState();
  const [lesson6, setlesson6] = useState(false);
  const [step6_btn1, setstep6_btn1] = useState(false);
  const [section6_1, setsection6_1] = useState(true);
  const [section6_2, setsection6_2] = useState(false);
  const [section6_3, setsection6_3] = useState(false);
  //Lesson 6 End

  //Lesson 7 Start
  const [lesson7, setlesson7] = useState(false);
  const [clickCount, setClickCount] = useState(1);
  const [btn7, setbtn7] = useState(false);
  const [istruefalse_7, setistruefalse_7] = useState(false);
  const [strokeDashArray_less7, setstrokeDashArray_less7] = useState("");
  //Lesson 7 End

  //Lesson 8 Start
  const [lesson8, setlesson8] = useState(false);
  const [sect_8, setsect_8] = useState(false);
  const [sect_8_1, setsect_8_1] = useState(true);
  const [istruefalse_8, setistruefalse_8] = useState(false);
  const [strokeDashArray_less8, setstrokeDashArray_less8] = useState("");
  //Lesson 8 End

  //Lesson 9 Start
  const [lesson9, setlesson9] = useState(false);
  const [istruefalse_9, setistruefalse_9] = useState(false);
  const [strokeDashArray_less9, setstrokeDashArray_less9] = useState("");
  const [less_9_q_1, setless_9_q_1] = useState(false);
  const [less_9_q_2, setless_9_q_2] = useState(false);
  const [less_9_q_3, setless_9_q_3] = useState(false);
  const [less_9_q_4, setless_9_q_4] = useState(false);
  const [less_9_q_5, setless_9_q_5] = useState(false);
  const [less_9_q_6, setless_9_q_6] = useState(false);
  const [less_9_q_7, setless_9_q_7] = useState(false);
  const [less_9_result, setless_9_result] = useState(false);
  const [name_9, setname_9] = useState("");
  const [checkQ_9_1, setcheckQ_9_1] = useState(false);
  const [isfirstquiz_9_1, setisfirstquiz_9_1] = useState(false);
  const [issetQuizAns_1_btn_9, setissetQuizAns_1_btn_9] = useState(false);
  const [quiz_dia, setquiz_dia] = useState(false);
  const [invalidAns, setinvalidAns] = useState("");
  const [questans, setquestans] = useState("");
  const [sectbtn, setsectbtn] = useState("1");
  const [checkQ_9_2, setcheckQ_9_2] = useState(false);
  const [checkQ_9_3, setcheckQ_9_3] = useState(false);
  const [checkQ_9_4, setcheckQ_9_4] = useState(false);
  const [checkQ_9_5, setcheckQ_9_5] = useState(false);
  const [checkQ_9_6, setcheckQ_9_6] = useState(false);
  const [checkQ_9_7, setcheckQ_9_7] = useState(false);
  const [passingscore, setpassingscore] = useState("");
  const [corrScore, setcorrScore] = useState(false);
  const [score, setscore] = useState("");
  const [score_s, setscore_s] = useState("");
  const [myArray, setMyArray] = useState([]);
  const [myArray_s, setMyArray_s] = useState([]);
  //Lesson 9 End

  const { id } = useParams();
  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };

  useEffect(() => {
    const userStr = JSON.parse(localStorage.getItem("users"));

    if (userStr === null) {
      window.location.href = "/login";
    }
    changeFavicon(require("../assets/admin/images/f-icon.png"));

    document.title = "Start Course Lesson 1";
    if (id === undefined) {
      setunicode("");
      window.location.href = "/login";
    } else {
      setunicode(id);
    }
    let formdata = {
      code: id,
    };
    axios
      .post("https://jlmining.app/getcourseDetail", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log(res.data);
        console.log("cor");
        if (res.data.row.length > 0) {
          setCourse(res.data.row[0]);
        }
      })
      .catch((err) => { });

    console.log(stepbutton11);
    if (stepl_1.length >= 3) {
      setstepbutton11(true);
      setactivetab1cont(false);
    }
    //Lesson 3
    if (istabSection.length >= 2) {
      setstep3btn_3(true);
    }
    //Lesson 3

    //Lesson 4
    if (istabreview.length === 4) {
      setbtn4(true);
      setStrokeDashArray_less4(365.36);
    }
    //Lesson 4
    //Lesson 6
    if (istab_6.length === 2) {
      setstep6_btn1(true);
    }
    //Lesson 6
    if (scoreCard != "") {
      pdfdataget();
      setscoreCard("");
    }
  }, [id, stepl_1, istabSection, istabreview, istab_6, scoreCard, PdfcardImg]);
  function formatDate_notes() {
    const options = {
      day: "2-digit",
      month: "long", // Change to "long" for full month name
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "Australia/Perth",
    };

    const date = new Date();
    return date.toLocaleDateString("en-GB", options);
  }
  //Pdf
  function getimagedata(urll) {
    let formdata = {
      url: urll,
    };

    return axios
      .post("https://jlmining.app/admin/convertimage", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setPdfcardImg(res.data.ret);
      })
      .catch((err) => {
        // Handle the error here
        console.error(err);
      });
  }
  const pdfdataget = async () => {
    console.log("pdf");
    const cc = await getimagedata("logo1.png");
    console.log(PdfcardImg);
    const imgBase64 =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPQAAABGCAYAAAD7LbmAAAAAAXNSR0IArs4c6QAAIABJREFUeF7tfQdUFNny9wxZMadV17gmJCgiopgjiIKCCAqSJIgKIojknKMCkkRFMkgSEARRMWAEUZAkillXXdMaycx8/+qeZrp7ugd239td3/m23zlvZfrmvnVvhV9VMRk/6NP46MW07x9bhgoICHZTD7GTwWAII6+6mF1M+C+L1S0oMWXs/aFDh36Cv9lstuDHjx/F/8gUBQQEBIYMGdLCZDI7/ki9f8v+uwI/wgoghPCjPWw2W3iFqsOdJ89+kxYRFurT8FgsNoPJZLSeSveaLSk5vhkq5RffUPP0T03q30+0FeibuiFYAvQVm80Q6Oru7j58yEZprsyke33q+G8qxGazRd+/fy/CZrN55sFijWT/9BMDDiGaOVIPEtb53bt3onRTGDlyJLTJIr9ns9kCv/3G6Ccg8I6wf0aOHNnNZDJhrXkeur5GjhzZymQyaQ5ttBk2m818/ZrRT0jonQC+4a6ukawxYxhQn2febDZb6N27d2L48kwmkzlixIh2usOazWb3e//+vRB+jaGPsWOZLb19Zj79dTCZzPbe6mPvYa4MBkPk3bt36G1F8XC+N8yji/z6hyToG1XNcvpmgVXCwkJMZIBcmusZP/mn9vZOxiypieV56R7LsELWTnGHc/KumIuLY9+VXAv/N5PR0dnJmDB+VMOloqA5TCYTWIAf4skvvKEWdCgrhslgCgsIcAiMu4WZLa3tYmaGym67TNWi+jrgG1WNci5eyUltre2jBAQEurHmYMHZDAazra1DbM1y2eRAL5O95DZtXY8eunylbpuoqHAHUhz+j81gtrV3CAZ4bNdSWil3GV+noeHF1D0O0Sdb29pHCwoKdEEH0F9be0e/ZYtmZRz0N9vNb9zegalep0oqLURFhTuZTAabUx/mLepir228WW1pPr7+06fvxuzcF1Hw+cv3SUh/yKnAYHR1d4sMHz6k6XCmx5rxpIMnPrnU5HB8kb+IqAgcYGxkHWBObR1C7va6JhtVFU/RjfHjx4+DTfZE5b1+81FGSFCwE0gSdharmyXcr7/Yq6QYp5Xjxg36QFefzWaL5RfdWFt+tVb14bM3Ml++fB/Z3cVCNi3+u2DzZjIY3SIiwt9Gjxr6dOF8yeJt2ouTMa70hyTokKiTDpGx+YEDB/SjpmaKlfn6rZWx20zNzdFay5dzqostW+dw983bj9OFhQT7tM+/fW9jbN20LCLI29i6TxX+pkJa+r5nbt6+r9y/H/Vl+u17K0Nn84rYUF9TvoSBH+4mPd+zt27fX9O/P12bbQxd7WWRId5mVvh6z5+/G7t2s2t9R0fnUEFB7MJkMthsFqOrm8XKSXCUk5ObcRdfJ+RQjt2ByJPBgwf1x/3MZHR0dDKm/vJz9bkCPzl+xLJGw6P+06dv44R6viN6ELe2dTDio2xWrFkx5xK+fkLaWSNnr8SEQQOhP+6hDYe+5MyJN4uzvRXJ/alscrve+OC5opgoXIzcOl++tjD27Nzg4bxvqzfdGIET3G0TdYq7X1FS7OzsYowdO6LpSkmILN0tXVBUsT489mTwo6evJQWYTAbMkbuuVD2iYwM+rau7mwFzmjJ5zL24gzvVZ86c8uCHJGgtA/9zd+42rxYTE6GYEfFWxSbX2dnJSD1sP2/+fIkqqHT1auMCI8vQGyIiwsCKEzYSkfvmtve9pY0REbJbdePa+af/JlrttZvHv/32k+Zmn8bWto5hggL4iXDH/e1bK8PEcG2wu72uQ68NMhiM0vO31uzcF32W7oCANmAtIoN3rVdTWVCMbzOv8Lq6tVNc3oAergd929HZxZg4flTtuXx/OTILrWMcVFJxu2ltP9L37OzqZsAtc7k4WJKOVb909e4SY4vwcnLdrq5uxrBhA5+fSneWHjly5Ff8GHdaR6WWllVtIx9WsE5GekoBXk56zvjyjx+/mrhB17u+u5s1QICwxgwGHPJbNJceDvYy2UW3tg6eCWEnsi9ZDxhA4PAZ37+3MdTVFsaFB5jvpKobHJFrH3WkIEhEWJghKgqiJQUr2ssHZTKYjC/fWhhys6ZeyM9wX/XDEXRz88txmoZ+9Z2d3YMFBOAGIItHvJPu7Oxm/DxmeOOFokBglRFlVuDBE+4x8cVe6KnZ+9PdzWKIi4u9Lczwkxo7dtD73mv8PSUKz95at8c26rR4f+Jm4fbOZHz91sKwMt/ost9K078vo9I28i+pqm5e208Mu52Ja9zNYjP6iQp/PJniITV58qg3+DYdPY5HZORetiISNJPx/XsrY/OGxbGhJPb59evXI1W3+Dd8b2kbib/R4bvCmvfvL/Z7cZaLxOjRo99SjT0oLNMt+thpb+53RL9/S2s7Y+XiWdnxMfu08fVesNn9dFXs6t6++zxFSIggciN1Yg9arVm7Wu48vk56ziUdJ4/j6QMoOEKos3r5nJyjh/Zq0a3t2k2uVY+evJ4rIkLU98BhEOhlvFVHc1kmue7R5BITr4D0YwMH9mPAzUx8sL973/twCIAM0tbWwcg44jDvhyPoE9kXtzp4JmSgi9u3B2WVl0YGeZv0sIcbdbzKG+49WyKKsFC9P62tHYzFipIFyXF26r2X/vtKuHolhqZkX7AdII6xq7x6LxA3HGw277Mw3RDW28jKLt9ZamYVebmfqAh6IfA8TEZbWztDfs60s5mJzsr416AMU9ZwvvPk+dvZZGUlfINQb1NtrU1LsvF1Ss7dVt69L/IMeltihzH6XxYIqUxmZ26im/TMmeMeUI1GU9/3Qk3d4xVEVhg9xFxsdXaaG6vE4etdq7w/z9A8qBJuPS6dMBnd3d2MAQPEfstP9ZMiy7PWjnFx+UXXd3B1LdwW29o7GXKzp1zJTnJZSjW+xsYX0zYb+dT+3x0ixkQ65MyNxWYICjK/Z2d4Ss+cPOYpvi7oFLaY+N3s7OoeLiQI4uAf0mVSfmLgPkJ9THV+OILevT86qaT0lgGdbEc1G2APD4VartugPK8E3jc3P5+irudXy2ax+zNJLBTdhgeicLHdutvceF1sb0Txd75fp+VW2fzw13kgOqAPL4cCH9PDxWCnse5qwuamGqeOSVBBxa17G/rRyONQB9bCYsdGZ4e9mgH4Nmprn0hom/jfFWAyRdDNiz4sFoshJCz0JS/ZVXrq1J9f4Ou4+iQFp5wos6M6oEEOBDk68fB+xcULJG+SxwvyupqOZ0NHR+cQPCsMiv7ublZX1nHHObNnT63H1zsYddIuPDY/mMyZgby9aL5kYcoRuw2kQ0pklZpjzctXH2YKC/PqWkCUmDxxdH3pSd/ZVBp/kNc9/FMTyP2BbCslMfFawQmPxeR5WTvFxZw8dW0XsQ73u4LFBg477Gtj/xBEOFbqBw7UgwE7tH4ogn7z5o24pkFw/fsPXyZxFSB0U0AXANi2gQP6vT6Z4iM9fvzgj1A6IbXU2CMgLb6v7DZsEBaL3ZGd4CIr8wOZq+Ak197uW8tisPsR2TIiUcPHDPYx0d+isTSV32Fz/tLdJTv2hpeLiYqQ9ArEgwJupeMxNouWLZS5jm+Pbl05yqarpzI8lpD7V9X2uNHU/GKBaM+BRCzxvaWdER26S2298vwict2Cohsb9jrGFaA3J/cWA2XT+J9HNpw/FQDKJoLpZptZUNGNyqb1XJkbXSs4pOwsN+3bs0udwMXcuXN/9lbTkDtCQoK8nC9gHLq6GcOHD3pVkOYkQZbVYbyW+6OTikpvGYiTlIu08jroRDS961rbOkYKkm5noOHWtnbG4EHin8TEhFuYiP0AOcPZbe2d/b59axuKHuzEGx05GP/v4EmKs1f4oQiaTgHCb5MistTSWdnxUVxZynRPWGbZ5bva/JQ++DYRbevUn2+VZPso8Ovr736XcuKCgYtPYlJvBxMoXyKDd25QW6dYyG+MumbBeTcqGtX798MTCPFwQDbwsEFP89McZUaNGvUN357Z3vD08xdqdMjcExDLDsO13q72uh748g8ePPtFQ9+/jsVi9ycrm7ByUNfHVd/EUGfNcfLYHdzjD504Wb6HrICDA0yLTl7f6l///XvbKLymGN3wnYw0nNIU6+vwsaLd/mFZ0XRrDNyHqIjI51MZnpITJox8hR8jR16v/e3dp6lkS0pLSzsjLtxSWWmV/Fl8nYzci1sc3BNOkPuDMXZ2dXXvNF5vv0V9dZKoaHuHIGcS3d3dLPi3m3962Jlzt7eTlcVwqQ0a2P/12TwvqR+KoL2D03yOJZW69raB8QsEG8LLWW/79m1KifD7p0+fhoKZ4+vXlrH81f/cVqCN7RTaz7+bgMn9We6POV5UWrGdXiGG1oBDLS7MWllplSxh8+Db4387c0tCW6uWzc46FmmzBV//1St2f23j/XXv3n3+hcw9QZ3DYXtWKa+ae4GwebMu6Dp4Jabx+56w9taW6k77dm0KxNcFgIWKJiib3shRKZt6l9e5raHa9GEPLhcHAdvchu/HcPeBk+VX6zToDn/g3oDDz0l0mSUlNbERX7eiokleb2fILWFhIQLHAwQ2YEC/3/JTfXnldee4uPxTvPI6HABr18xNjj24x5Bu32XkXtZ19DieRj7gQP+zRFEqPyluv8YPRdCqWh7XmppfLOyrIgtkDUFBgW85iZ6zJCRGP4GFKDpXoWy5L/YMmQUiLhLxVqLbkP8kQQPYYNk6+9o3b3+fxteOzmYw2kEOjbNduni+1BW6MeuZh5y8dqOBduPib0wPB90dJgZrj+LbunqzcYHRTl4zIHY75OZ7S48fjIo82GNlH3v0VPFNUyplE1YGblt9nVVhvi4G+/B17zY9nrFVP/Auk8kQJcrrbLDVfstPdZWaMuXn5/g67n4pgUnp5x14zEct7Yz1SgpJ0Qd2G+HLf/jwYdB6bZ+G3z9/HyfUY1PnXUHQICfG2S5ZskD6Kv5teGye7cGovFAqeV1RQeJ02lEHVdIhJbRK3an65Yt30nAI4B/gsg4FmattWL+QR/TAyvkEpfseSyl1IRM0Ik7s1bLes0Mt4ochaNAWahn53uXKi2TlD68yCGS9WdKTL+Wluq3AJu3olXgwI/uiDXnSRGUSt62ubhZj6OABL05nuUoPHz78yz9JxPi+AcllYHbgNvn0J48PbhCYQ8YRR/m5c6fephr/hfLqRWZWh66IihB0WTxFEWUTi92VmWQvKys1rQFfIDQy1/7Q4YIgsvkItQ5IFyTH2RKsA2w2W2SFmkPtq1cfZ1Apm7C24WZat0Y+Pfqg5TZ8f8fTz2339Es5TqVskpaceDU/nZ+8DvgFrpyJsPUuBkaGuquT8H1cKL+zzHRP5CWyjZtbBt0niE0+yFxDbd1CAiJNzzT49PVb99aR60N/+yw19lvv0jiA7w+R181C7ggJEuV1hK0XFfk9P9VTatKkka/p9uCGrV5XG5ueLUIvPHRsyPfv6manxjvIKcyZXvPDEPSR5DNmvkHpR/4oOmyPubqjndWmIFgEcMZQ2uh8++lLXrMK3SLBhlq9UjbjaIS17o9CzDCOqLhT1sGHcsKo2VXugcRhCTvzUhxlJCR+uU81BwPz0Nwr1+s3cWVf3sMR6nHAIXXn8v3Bnk/AV+sYB56pvP1AWUyMaAbE3w74vivu3J+tbxp8R0hICKdsojiU2zoYCvIzzmXEOyrh63PBIZi8j9YFZZOxwVo/DwddV3z5e09eT9LS8aojg0NAWyzAYLbmp7nITJs24RG+TsCBTI/Y46c9Bw6gNwlCeZijh8M2cxMD5SNY/RcvPg/bpO/W8PVb62i8cguT11OP2ckvmDuTcMAeTija7R/KK68DByAnO+1cdpIzYQ3wY0XBL14N3d1scbw+AjAYY8cMbbpYFAziBEBxf4zHaNfBnMvXajWJChsYG/XmQ5QInV2MlGP7exYO3UT0GkuqmdKd3v/0qujtCDl1/WajWr9+ZLQccT04YkdrzglPKYlJqNiBfy5dq1U0tQi/KiIizCEsOs6HyQAIqdbGJTGhfqYW+DbevHkzap22X0NLS/sIQUHuluEochgpR7nfAKsXdbTQKjg8O4J8o5PHBwrJGVPHVRdle/fAP3nlde6Y6cAhGVkXdB29EtPI5rGOji7G1F/GVJXk+s4j9020cdN/cdgje3aqudvt0fLBShWXVSlZ2ESVkmVvkNd/GjnkUXpJiAwZL25sEZZ98crdzeQ6ZNgy1UjSsi9us3eLTyUf8PDNNq5bkBB9wNIYo5Z/eu8yiKcdva0NP1C4TSaMG1V7voALNaSTaYgTJNr7EON/gqf0zJlE4/8/uSh9Ww+O2Y7FYvQTE/1SkOYxk6yFhTkY7TqQdflqnVb/HqQZFYiBc/t9b2Mc8NmxebPGolz8/On0EuTbAV/H0Dw078qNBnX0QKIXn0Cr/hMJ/nmtsn6e4Y6DlWTYLmKiHNj/dU6el9TEIUN+x/dHJ6/Dja63ZVWon7uhHb78ixfvf1bd6t7Q0dE1mE4Dj5UHOV9Hc2lMoJdJz0HnEZDqn5h6zolKXldRUkiKpZXXv41DwSTcB27oY1F7l6xYIkuQ0fFlDkbn2xxLKgkcIC72HZMnAOgD5lZ/DyMdTCH5Q9zQp89UrrWwiynhr8gikhiCDtu8LCLIk+tIscXI/0xVdbMyUa1PfcNDa2A/lZ456Up+hjslCuifIurSstsrd9pElvXF7IYopQaJv8/N85pBVkrdvH1vrr5Z6A1hIUFhvGKJal4gxwkLC33NS3GVJiub3HyTQpIzyvaTbz+wIa9Xmp8YfWDXdnybv//++5C1ml71n798/5ne0sDFEQwQ7/fhVIavBAa5DYvMtQ8jyOto6yCvL5ovVZRydL8avj9wzVy1wbHm5a8fJMnyOgI6CtyttmE90c5Nh0lH2yUpTVvaGUqr5mTHhe/tgZlu2Op5rbHpOY8CF7G6uOpt366DWl2wh9oky2R0dXUxhg0d+PxUBi8mnTRHoZdfvgxifuUiegQEGEwhobY2vHnxhyBoR8+E8IycS3t5FVm8i4tNEj5UTKjlunUcdBiKKvKo7+joGko8cekJui+szj9B1J6BaX4JKaXOAxDZjj8sEG64kSMGP8tKCJUk++2a7olIPX/pzjbx/gCj5d8OHG4y4H6axnU/xea+Xsv95v2HL+ej4BBsPZmMb99aGH4eRtv0tFem49fp/KWaFTuswi/wQ6PhlToMBrMjN8lNBoN/6poEFt+suq9CpWzCtLn4/nhFLQL38iE3x03ql59++g1fhxqTjpUg7hmOjHspO8kZUb6i8rpnPVme5biqt+Ukus3CfPKxFgPDs11jjhb6oPI691uACLFiyazc49H7Nv839to/TtCgyFqj7lz97MU7GRQf3DuuFbS6gwf1f1ma6ymD+YGiGPDEDDILRLtIbAajraOTER9tvXD5olk3/huL+d9qQ13Hu7z+3lMCDh28asBdDh5g2RCnYAboEboZ48YOby4rDJTGO+5ztOQ3hYXR2xn+19nVxQCHF16nFxQbbWqo7Otuv80NP48ecAib3R8PpQLZXYBJrWzyDU73OpJ0xr0veAJMF5IWZ6+goDDj1qtXX0ao6bg0cMEhmDaXV2eCjTP2WKFlQFh2JLk/IMS5c6ady0okKpt6MOnP3s6mQl6RvyPI4VN+GVNXkuMDiic219+ASJyoO+hYWnn9bt3jFUSTLAeTbq+z09yQiEn/s3vpHydoFHoH2lBQ5fdtOFTgBwvb6PjTZyuN+3Ibwe0Am/unUUMelheHzKJz3fuzi/qf1Hv06NcJ6no+DV1deFc+JqObhSK4+ouJfH/+63spzG6KKH0mj6kvzkU2W090kR3Wh5LPlt3Wx0ApcJOPHzeytqO9c/i7D59/Roma+7QCOCViL49vcdqJi9ucfBI4yhjuzQWbd/rUcRWns70XkOeroedzsbb+yXLUoYL61sPXAUtDZMguVdW180/TiV+gbBozatiDSxTgEFShWqfZn6RARDDppqquDjbafvj+6GzcdN8N1m7E8EEv8lIdJYG9hcAZ+YXXeQJnoGLg8vAgz+02+LYg4IK6nmdDe3vHUPy6w2HW3c3qzjruIEvGpP/ZPdQ3CvqzrfehXnhsvs3BqJMH+3KaY83Bh/J1NTQw0FmVAr/xQzHRDQFY9g0q8+MPBe827cMw/7YiWfnlm+1c47O54gdKRLDpNdQWRbe3dw4qOXdLH9N+I04AMydWFWR49Ghxb91qmLPN/OBNISHBHsMzKBH3mqubZeWXu71992kCXrblKJtencvzkh5CVjbtjzl+igKtBsom/a1rQnzd9O3xi/Pw4a/jNfR967u6ugaRDw2UJWXy4MihLX9PI8NtWiuTPXxTgxIzztrzyuttjPVKCyjldSVNr4avX77zIAPpMOkQncQrKO0Y1Z5jsdndnJul58QD/YKYmMjnkmy36eDmuVLVsfHlq/c8zhyovZoXgkstrzMZ4MM/ftzIhvMFvJj0P7vh/nGC3mocVFJJ4fxONyEMHZad4SGDuaVhsEZ6gAD5lkBNNFTwwT+7kP+tejbOR2LzTl3bSQ6bBEiiAC8jrbJLtQYXy2vUxDi+zIir49wZZZnHHVdjY9hpE5l45nyVIXY7w8aeJze9ZNPGxYcd3eML0HXi3raIsklRKj8lbr8Gfh4IOETVoebV648zucgmlNWHzRsVshu5VfF1cguva+xzijs5QJwot4NoMH3qz7cGDxb/raLqvqooznf427c2hq3VJnsr840hals9rt9reqmIOvxzHzjE/dz0DfW3rknG/04Eh3Dn1NXFYgwfNvBZfpqjNBmTbm4dlXqWIgBCe0cXY/WK2ccam16sevv202T00EOjsQDmJi/bexqrpVNIQ9/rnqCggCCeo+TrQ+55PDwj5/Je8prAN9XcsPjwAX8zQvAEd5+kwLqm50tFhIVoY5G1trWJqyjNT9hF8g78RwmaYzoARRbBPY4fcbS1dzDmyEy5kJPiugor5xOU4X00ucStr7c8HAoiIkK/F6R58UXm/LeItK/tQKA5KmgggCMEBQRa0pOdZHz80xOra5p75GtglRcrSp9OjtuPwAwrqx/I6pkGVwgJCvTczsAKRodarqm627Q6IeW8AxV00HGvttXuHaqR+LFCbDeDHYG3hYV4scri/cXeFWU6S40ZM+Ydvo6ta3xUTn65BZVDhZHOmgBhUUH2scQzzng4KNzQO4zX+Rloqxxcu9n+BdmZA5HXBZit+am84BDf0BNeRxKKeeR1Okw6ePRtNgqppcKkg/gS4L19/fGks4EPn7ySwSC3cIR1/J/SMDfJWeZO3RMFj4AUHk8+VHE2tSw7yaXnYIV1AUz6Wg3X24+fvZlDhUkP9jHeskVjWRa2hnV1T2du0PWsYTAZIvSBDxiMr19bAI3m4rhvCyGoxT9K0CdOXtJycE/IotZuU5MBAubfpW6/z3JTCFaiNxc9ckuw+PJzpp/NTHQiOPD3lfD+qnI1Nc1SW0yDawQFmEL40x+w2jNnjL9ReMJr4TpNt5rmx69mY5sDWHGlVXI5ceFWSESNndZRCWfO3zLCCAZxbZwx4UrBCY/lKlrulY8evSJE1sDAIclHHOcqyk+7g58bLzgEfQvrN2/O9LMnSOsHyiYlDec7TxFlE2/0jiMRVquePvtN0u/ACYICC8xf2puWHV6gMOO0jUNcIXk/wM05fcrPVcU53rzgED2fizX1j5eDSyj5Rnez22ZuZsRFd8F7wKQb7gy5IQoupLgKIHYMHiz+qiTbXdLUKrq4tuHJQrzLJ6xz9AFL5ZKyWzpFJRVGVOAQenk9oJbJ40OOYNK/5qcSzYT8xAFsuPz8yP9Rgu4LeB//kTibj50e5zh33rxp1fCu5t6j6ToGQQDi50SMoCM3rrkFNLo2Fpq2Nrs3HvyriPPPtBt3vHiX34ETMTxoIIiFtU0p2MtZz2H5eofmV68/TMXsrcD6qq9XTA4P3GlYVftIRs84sFJAgNmzFnD7hQXvVJs1Y+JdVR2vRwJMBsEmzQnf1HShKBCBDuLHbbAjuODqTQiGwEssVjs3OO3fs5ngIXWn4ZmkrqFvjYAAk9AH3LDCwoKfywq8x5+73LjJySM+kSsjoxFSViyZnT1oYL+3eadvWJCJBcQjPe0VB/3ct9vix0fH4XH827tOUGDSaQMgtLYzlihKIx5L+uYhZ67dbFRGQzShcj9whrtM1u0rPX/bBK+UxMaDBizkBYfww6RLzpzI40NOJw7g580xVT7JSQqVGT2aCUCTnucfI2h+vqR0xIDDGkMgOsSxPS6pxNwvOONwX9ltJFpiVxcrLc5RHjsU/gzx/RV1TCwPZl0or9Uib2i4wWIP7lm7drXcuUVKti8/fPw6BouXBez0Nq3lkf4e260s9kcdP33m1nb87Tztl59vlJz0WZiYfm67e4+zA1fWRJSDyooJh0J3ItBB7AFwiJKmZ8PXL0Q3VH63w9HE0h0+IWlxZFsrauOefCUvzW3pmXNV63fuiyzCu4RCm2Jiwp8gHnZ7e9dQsrGDXl6/orHP6dhJqoCFk8f/VFua70cRsND/TOVtMvgIxWvbW222sTTfEG5lH5t4quRmjw4C1gTGKC4u9rq1tX0EAFnIBDZ82KBnBelOMjwBC/dGppVeuK1L5UNurK/s7+m4zQVrq68BPlCuTD4tLtxSj7wP/zGCvny9bqHxroPXRMWIrA8voXA3HxKuVmtlWKCHUY+rneHOAyevXK/ToAcxEEECgP8eN35UfRnqgMATqPyvINS+tPnu3buBG3QD6j9+/DoBH9yOE0jv/YVTPtNhw69R93j07XvrMExLDTfwblM1L231ZYfXbXFtZrAZnMiVqI3Tz227nv7WFWk790aklV6optxY/u7b9fW2rCBEO0HBIREXyLczasIZ/CQ32U5m9OjRhNvBbO+h9PMX7+hQsaPmxus9XWy3eJXfqF9kvOvgVYSd7dl9TCSMETxkGCaqYRalBIfQBUBAlE0bl8QcIGEsK52/AAAgAElEQVTSIWDh+i0IJh0XsBCRcxmdXd3sNI7Hkod/2oHE9NJ9qBKL+3SzWKDL4PmcQGCrltP5kNvXvXv3e598yK9dq1U02B12HYW88loD0I7R7+rhvM3UZJty/A9D0H4HMj3iejxdegeTwMARv+WDFkrKq+edg795QQi9kw5iK9RcHh7kRbQV9l7zry1x8UrNYlPLiCvkaBR4eR9YzPVb3O91dnYNxDY+zMfOcrPtb28/jkzOuuCI3Vag4Jk4YVT1uXx/ecjEsFh5/733Hz4TQjtxlE0teSnOMtOnT3yMn6FPSIb30US8opFrPlNaKZcRF2FF8E57+/btAPVtgfUfPn6dSI62CVr0I4f2rly9XPbivXsvp28y9K5nMoisP50TDp2+AwGHbHKtfvLszSwICIgHJMHBH+JrqqWtvjQHP6fT5yvXWtrElJBvSxA7xowe9uDS6SDAJLRHHSncFxyRfaA3xxKsbbp4dNdvNSgYmB2ooMKkDxjQ701eio8UFjYL2gKRyzs4LQYQgoICTLaAAJNJzpOCiBNsdmf2cZfZVOGy/rEbesNWz6uNTc85vp34ZcffqFy5t6u7izFk8ICXJdnu0sOGDfsMNU6dvq5q5RhXyGXf6GGeWA/AvkaE7PqhYm/D2ELCslyijp32JSLd0NN47y51R1vLTUGc4IeNLBZbBEN7wWZcuWx2+u2ah8u/fWsdixE64vLnrLfdZJtSYk9wAlHhniBVQACgbJox9efK09ne88nHlYae96Xa+qfLuOAQdKvAeDwd9cyM9ZWO4esgt4tF2HVUOYUzH3WzGEMGib8syUG/G4AswOzT2tYxmDrOOPH7IyGKKeR1YsBC7NZEYsMBJv3z6UxvqfHjR/yKHyMasPCCHa9DRRtDVXl+QlTobkTsSM28aOjik5hIxgJQHToIOITF6spIcp0tR4powpXXiYgyxEy4gDdgIQRcePzi4xSx/sJt9xqfS7n7pWQJMPF4KzQ5wS8TR1efyfOdS5UCqE8EDTl/CosrlFisbmG2gGAv1ynAEwXBdicgIiTYsl5ZoZTM2mJROfnFmuJ+CNzNsEIuLe6QVY/csN/lWGR2wRVLei05kcCR0DDiYr/lp/GGcv1r79/eW9cy9Dt/p+bhKvwNDZsFNNwYPLW6+onsVjP/amD78CFqgYghTC2mGYfbefzPI+rKCgPnwY0TFp1rHxaDD06AjgfsvwY6q4J9XA0IAfoBHLLJwLehs7O7hxOA8hxlU2d6kqssefOGRuY4Hjp8KoAsP+PD43Da6LdExe7eu3efJvYWCBI2GsjfCbH7Fi9VlL6GX0U6bTA/h5v1Wp437z98zsGkc1uDwy/Ac7veNq0VafDr2bIqJXPrqFLeyLO8FwY/EU7XJKj4ZlUTJSZ9v9VmGyvzDeF0OwPiybn6JiWR9zaIE9qay6KCvYz3UNXtE0GDPKVnFnwBcKhIBXytnuQ7nOY5f4PWb8G8mecLMtzXkDum0/zx2/YgK/rg0GEAeli1wbGaysOGrh2w2S5SlOYBUPRObn9tiSdP3o7W0PdqJEMDOQH7esAR1yruKRruDL0OmHe84ggIH/83bFB3+20mpobKSOC9LUYBpVXVD5TQw4KoEIsOsVBZv1bhDH6GOXnlmrZu8Tk8yqaOLsbkSaNrSk/6grKJcLBrG/mfvV39cA1VAAS8jRuJFbbZrebR49ezyKYt8g3IX16nD1hoZqTi42an446fU1PTm8mbjTzqyA4VSGxwBrMtO91VRmrq+IdQ5/qt+wqGO4IriNFiqLk/ILBNGxbHkvNzUScYQJVrcAikHrbryfJCtbt22USmnDlfpcd1e+Ucwt/bGGH+O9Q3bVhU8KcJ2jswzedYyh8P3odpDckdm1lGZJy/XL0VHWzv2QEQNkpI8HNusov0tGnjXkJ7aIC24FvCpIDqaF/UTARsdOf9W3bt3L7+8F9Lon+s9VOnK1StHGM4ogN346DRVOQyjnLkVa6iCjOn4PtBT1mAE44ZPbw+9XSQAjjY8yqC0PYxZVtxlosUOWsFP3CIlsaSqFAfU8LtAOl6Nm/2aWhpbR9Ojt7R1dXNOnHMjpDvSsc48Fzl7fsUqY6wmwL9fqiySTbzWKT1VvxMEW2wYUjd+/efJ/Pku2ptZxw5ZI3I6/g6KCY9MXUgKV0NKnaMrzid7dmDSUccUvQCGllslihXSUccG9Y26DBCfE0o5XULG8wlmFsXJ6/zBCzE2gQos9b2/fXo/LgOSxxA1KfCDC8pKt938l1LuwtRON4LRXwsI35bFo1zxOrOOOosN3fuL5BVoOd59unT0M2bPOpRcwhV1gDek7CtDbIXTD2fnezcc9tzWTy8JpJehkZD9bA7so7/WLG3YWHo3EfR0DfcgH2nztzcaGUXm08dBRSd+9evrQxXu607dmxfhwT5o3N2AGXT/LkSJenHHdbhvw/H++3OsxdvZ1FlxzgYYLpJU21JHr5O0ZmK9ZZ2sUVkf3YkAMLYYfcvFiLKph4b907rQ5mlZXe0qZMpcL8hzN/VQXfHDlLAwmvX7ikaWIRc7+EYOYPBAhZmUwZAiDl2qqTChLx2iNixZWWoDy4AwuvXX0eqbXVpwlsT0C6I+wsIjC5goYd/ckBi2nlHKky6qrJCclSoBW10T6Iyjdsn2MJlZaZczE1xXUlHf72y3H8mCwW/2FRIojSb6LN/JDMGFTpss75vWXXd45VEjx76YwZxgZs85vaZk76g9f2hHmJuJPQDUsmrmTnlevae8Sl0OgMgoBEjBzcXpDrOxeyh7j4pwUknzvFkroA1xZRt+MXggEPuCpDQamA+EhER/lR0wluarGxy8U46kJpVxmPmQR1gFhw7FLzLDN+Hm3diWHLWBWuyWYh0sICCqxd5nXiYg0iFhbMltSW6fL1D7es3H6dTBUAgix2Qi3v5eoeG128+TuEX4JCvvK7tUXG/+YUC14ccRoQG/KcyE+LHSwd+gbq7TNe7O9ls6QmFRN7IvRJ04olzBu4+KXyCvfPeivzSsrp5J4UkZ/JGv6CjMA4QpDvlmP3c+Zw0pVyPnu5B/MPHEE/77duU/b2cuYb8H4GqOWacu8ye3EjoqOAAmjzxp5rSPD/QZiJG2vi00h1e/gDcoM779eUrEs51r5W52iFsblSKoL6BQ4h9IBFWpSaX56W59eTf5vbhXvHg4UsFbroe9A3oPagCIIQeynU9FFfgww8MBJfCpHGj7p4t8If5kwIWUmezpAtYiODbTYJuEwMWIq6LkCzvPZXYoartUdXU/GIuXcYPmB/0Z2Kg5OfhoEcIWEgrr6OY9LasNK68TrUHdY0Di2/e5g3wAArGY1F7lq9cSsy/jW+jV4LesTci7RwFIIEfMaBhX3hjDNMD1elZZSS3EAn1k5xRpu/qm5TcV3QYjBVO71iKYPD/NFHT5UZCskOQAvZFHyvcG3QwOxwyFpIfNL3qoMenM13lMLMeh7uqAysFHhuOQAdHDn6cdTxUhjfKCVXWEdR8tst4vaeT7RYvfN9osjbfWgaDTYDeol5xzO85iV4yWMx0rF7iibLt7j7Jx7nyLPWlQCWvIwELtXwbUXmdC/LAEICp8Q5zIZwtfoxRcYVWwYfwAQvhLZaUjxrTr2cWVHy9EjTUdPoKNAPm4TCbVcqrZhMSDKRnXtJx8oZsluQACF3gcVZzOtt7Dt2+AwWppoFPXUtr2wjM2wtudvhmQ4cM7DXcNF+C5oIFvtCYGHg/BJKWtb/Y28ITvGlZ7959KK1tHFQtKEh0PqAnKjTMjcGWVQQZx9wmMuXs+dt6fWXbkc3eh7hN/wRx77KNSSw5W2nIlT/RNUWTj5lv0lRb2COvBkVke0YfKfSgOsggMbmNhea+fRbc3E2pWRd0XbyS0sh2V1A2Ka+ck344Yi8hFjZ8bw29oDoyAAU7EKmUTamZF/WcvRNSeOJng0PJ1AkVhThlE7a+p07f3GjleDifXww5OnBIcektld37o4v5yOugbCK4HRqYH8i/eqN+IxUmnUrsgHFa2sWkFJ2p1KMbI8eH/E1Onpckb8BCankdF/mkB7pM3nMOnokhWbmX9pP3NhweyxbNOpkYu0+T3z7lS9C9ByLnbRrYgoUKkoWpx4hZ/qBk5JHCvSER2eF/5GZFw7ZarFm7eh6S0xeBSOoE1H38ne6Q4R0TWVv8TxAuVZ+8eHaUmBFli7DQl5NZzlLTxqFafXg8AtMOJKae5ciqXE0+enqLP8nM9ZqL31wWdrEJp89UGBE3JXrbejltM9muh5q1sKe8vH7R9j0HrpLRahDyachgcQKoB6tjYRudcPpspREZ3APstoHOah4bN9S7UdUwX9/0wE0yggprEw1YKPzpdCavvO7qkxKcknnejsc+29LOUFVW6AGHYG19/PhxsMpm74ZPX77/jE/ditm4k2gyX3oGpAYnpJ4l6R64FxgdOISjVKx59uKtNFepyK0HftqzpCZdlJSYeJfFYCEsBpPNBFQvs/7e0zm1DU+XUOmF4MB2c9zGoyAk7yu+BM2FZ/Y9VzPIFY7WWyx3m62PJnemaxJ0+mZVE0+mAToCg8kPHULManH2wp1V5taHzvclIibWLuocb2Sov3UlwTn+nyZsML1t2xl8i5vLGP3wVBlBYKx2bvGxWXnlO8mbGWRn613qdrZ7NoVic0KCE6x3qH31hpi5AlO2ZSfwQgdDInKdIo8U+POkdgFl02KZvKQY2034NYN0PcvXOdx9/fbjdKpkbTEH96xVWTO3lLzOtfefSGzVD6iD8GhUYadQeZ02YGHF/YcvOcombsto1BMuOAR7QxdBlWPjfpqX6sCTlA/qRsQW2B+IysVlCiHOgk5e53iA3evo4MJzyfOH+UH/5AfWkCoNFHADYmIiv+WleMhOnjzqDb99y5eg6eGZ1E3yy9sLssEmA+/6VpLsw29wCGu4Sj7tMM6rxMM3OSAxg9ccQNcOglcWZH7PpZDl/mmCDovO3x8WczKETECwWcyNVLxc7HQ88WPcsz8mubC0Uh9/48LGGDxY/GlukvdcPC6YowiCzBUEmgG2jw46iIJDmteQwyDDje5go7XHwlQtCj+eW7ea5+iaQwAECN7B3Uqo2CX6rvCEvyQWmhdfD+Tg9dp+Td9b2oZShfmF+VOBQ+iyWfLDpNMFLGxpaWMor5TjETuwcWZkXdJ38DpOqadBnDk6uxnJR3l9yJuafp2hoe9Zx2QKCPcxRB7fbQir+unLd4axrlKAt5uBc297lpag7917PUlrO29qEd4GuewEbJZJE0fdPZuHBL/vCVgHdXIKr6vbOsXlEW8XemUY1EFU/LgwsWhGQrdbj56Akz4xfxH1RJmM9vYOhozkxPK8dN7wtL0tzl/9ni6XMYgZRynAESaWYQUXyu9uwGcXQUwZxuvdnWyJpgw68Qa1QCyNDPI2scLPD8Ahmpt9GlrbOoZzPYqw3EksHnAI1I2MzbcJ4YkHx0RyHM+XlziTEe+gQrWGb96wxTcb2ja+e/9lAhX8E9jZuAgr3oCFWWX6Tl6gDCUqm5AACFN/vlWc7c2TDlhd1+tKfeOzxWQMBdnGTx5ncdktFQub6GIiJ4juVw44pJnjzEHIZglY9Y3bPOCGxgXw57/P6fYZ1Gr5vyD848aOqC9Id16CRbj9Uzc0nbKD2BhxoFTujVh5a8e4uPwi3jSa/G5WANmfTHaRmTr15xdQjhPRo1qQ5EBP7anDAVrQRH78q4m1t/ZfvvwyXF3PteHbt9afyAH7Bg8S//VMroc0+QPqmgSdr6hq6sF7cxSQr09nuciS0V50iiAqZRuMtbDk5ro99rGn0aip8BDCBN8rK0QCIHTi58UvAIL1bo39+yyIydrwdVW03G8/fPgrT6pYRNk0qP+rs7meUuT573GIjS8srjCmSq5OJa83v3w5bpO2X0NXJ9G8iYodjI7sBGdZKo8lGCeSpMA0tIoqWSBYcdTWKhyPDLEwofrOmnq+pXfuPlSiRkL2tjPgPXrPtrS2Qd7nN8fCbdb11Xef9obeZROVXHL+Vk8Y2L4Mgxz8HquDyFrrHWpek+Q5fm0iMZVlp53LwiXwoou/TNdOb4qPvszprypTcu628u59kWeI2kwm8hEX0+DN1bd5XatveNaTrQEUJSYGyt6ejnqEROtIjuweNB7XtIMq2wQ/nT7hzQMddPZKPJiWfcGGDPYArLLa+gXHI4N2ETYvHEgaeq6QrI1wIME5AIimxMP7FyxRlKqgWz/t7QFlt+88WElWwAF3slhRqiAlzo6czRL2EIBDppHBHnBIxR7gJl3A+sw5dU3T1vkIJSadjpPE6jY8fDFVW9e3nsVmi5LjmAMaz9eNG3WWPEfIJ7Zjz6FzHZ1d4hBauK/hqaEd+EZgqgXOUnrmxKpAdyMjWVliJtA/fEP3NXIC2jB6E3KSXL/OS/GRxstyUILOL5R6YNybdZ/lpn3Wu7hmmG2mQYU3bjWp9h7dE22Zkzep+XJxMEAPCazRX0WofW3XNzTd/UBkntcgxKaMnqtwcwD6KMDb2NhYd00CuS0VLberd2oeLgItKCgMx44Z/jTzhPMCclYICB6hbeh/DUARqByHtg+H5JoVc/JTj9oTonvCu5UbHCsb7z2bx2VNueOJDtm1ebPGUkK+K8CV65gEXkBjYWOcGoSmRQAxTVdLD0AACdo1N7WKSMsvvKYrTggigIYr9nU12mluTAw8DzoB9a1eEL+dI6+joYHgG48aMfhV4YmAWePGDfqAXzMbp7jIpIzzluSMpt+/tzNMDNceDPIkhjTC14VDcYmK872Pv3/5CS8WcDz2Phdnec3+5Zexz+i+99WKJvmI6JMBDU1Pl7S2doiCEwj1g84DHgBJifcXa5sy6adqtfWKx030lFP/6L6lvKEvlNcvMttz4Cp9NBGyTMBEgBtUoWBhoMHh2c5RRwv9+maugrCpkPO4uzsj0VlurgyKBefKeO04GY9qibhj+1Fjb8Oonzx5PelaZdMyYUHBHnVnN6NbcMjAAW9VlOTPUUVTqapqlrv38PlsIWHBLhaLxZSdM+065iGEXwmwJ5dfe7Cuq6sbwB6ILoPFZAEhsJYvnHGOzJ7D+3MXbiu/ff9ljJCAYE8UFxjPoAH931O5wALe+eK1KmVoVIAtwNmt3YwuFkNIRmLC7VmzpoAWm/Zpano843btM0Vyf/1ERT+rqyqeIW9kILCSsrsqDAZbkNsfg9HR1Sk8bdrYWnLqVuj4Vk3znKam57IiQsI9ogKsgwCb0bVwzZxSci4w8mBLy+6ufP/h4wT8GLtY3UITJ/zUtHiB5M2+HN6AGnvy6tfpnz99GwGfgKoOjElQUKh72OD+b3+ZOLp58uQxz6l8nfvSH2UHAWGZbrHHTnv3lQAxjKqL7dbd5qQ4wTAIorM89zSn84pCNLGTf7p9JtcP/HmRzcKN9wweWn1TMtB5wvRlYf4t8+8K/C+uACVBAwHW1T9dRmUTo5okP8d3ukTc/BYLzcqwKsTXzbAnKwNv+hH+y43F3i7M8JKmczX7X/xg/4753xXgtwI8BM3JrVTf1cUiRKvg1wjmyVSS69Nzo2Ll/wzuGhQjR3B5ljhKtbtU3jJ040JiUclNK81McF777xb4dwX+f1kBHoJOz7mk4+QBwPK+o8OAtdXTXsmTVBsWcSdNGFO6BcZSmOBDokK8KkOL8OvESJH8PxHYGXsL8/L/y0f+d57//6wAD0HzYnN7XwzQTFLB/CDomeoW37qPv38jhKbl1yIE8VNRkk+KPWBphJXj5tbt2yHDz/Om99n8W+LfFfjfXQECQSNZHLfb1b57/2kKqqrvXfmEZS7MyfOSJnudnLtYvdx8b8TFvsbMhmWECBKB3kZbdTRXZGLLulHHu7yBlC8ZfUc9PrDjjf8BY2//726Tf0f+v7ICBIJG8/6E3uDaL8nTwIoTM9AvWzQrNzGWNwO9m29qUPKJs/b8IlPge8BCsOYmOffEDmtqejpZ0zCgjsVii/cezABaQ10PqeCN/ysf5d9x/rsCf3YFCAQdFJblEn2syJdsiOc2znsjonGftu7YYYDGsMI/Kpqutx4+fi2PRrLoPRggRApVmDv9zInjTj0Y4ITUUmOPgLR4Mn6Xd8JE+zNVqtM/u0j/1vt3Bf5XVoBA0Lxxuviz3GjgPUZ7ZryT7KxZk5vwk4a0mFrb/SBxWU9a094WhUqRZWoZdqKs/O4W1CEBvYH5sduICABZCVJ9pcnIod76/zveu7m5OV6+fHl1d3c3U0dHJ83S0rLHJ/nx48cTraysDrS2tooLCAh0Hj582HLKlCnP6caVmZmpdvz4cRMREZHuCRMmPIqKinLgB0goLCxUCgwMdOjXr19LXFycBbntly9fDrewsIh68+bNWCsrq4ht27adhL5TUlI0Y2JiLIcNG/Y+Li5u57hx4wiIrCNHjugnJSUZiYuLtxA5LpaAoKBgx+HDh3dNnjyZ4Pbn4eFhX1lZqSgmJkZAk3V1dYmMHTv26eHDh+3IDj6XLl1SdHd39xISEuqMioqylpSUbIb+7OzsvMrLy1cqKChci4yMdOT3HTMyMjYkJSUZCwsLd48fP/5xdHQ0rBnBkQhfPzw83CwjI0Nv8uTJTzIyMnYzmcwW8LE2MzOLevny5URDQ8OE3bt386D6wJEoPj5+y6lTpza1tLSIw3dhsVgC8+fPv+bn5xdKDsIAfd6+fXuWh4eHu5CQUBf5O7a0tPSzs7MLWr169Q1+8+shaCROl4FvPQpkB/wvHVSNS+RImtPpEyoKM7khULHO6DIp0g2GyvWS45xe/+nLt3Goczo8/A4ZFLG2dJF0fmKsLQ+88e8gWH59gJJw5syZDW/fvh0H5czNzcPj4uJssDo7duw4eOTIEeTvESNGvGpubuZxUMDKgilv+vTpt5qbm6XhNxkZmdt1dXV8AyBqamom5+bm6o8aNerXpqYmKSxUEdZmenq6uq6uLhIhZceOHYeOHDmyF/69fPnykkuXLq2dOnVqQ3NzM0A6CU4a8vLyV6uqqhZRzX3KlCn3Hj58SHDsgCAV0tLSDb/99tt4qjqqqqq5RUVFm8nvTExMIuPj4y3h9+zsbDUtLa0icMWcPn16w5cvX0YYGhoeTkpKIiRPx7cBPuISEhIV9+/fl4XfJSUlaxobG2nDAXHWtbKurm5ev379vj148EBi/PjxvxYWFq5SU1NDAm4cPXpU38zMjJAXDH7ftWtXcGxsrB3V/CIiIsz37t17hPzOycnJPSAggBDiCVemu6qqao68vDxfBF4PQWfmXNa294zP7Ku8Cx2BvXj18jk5Rw/tRXIT4x+9HcEF13lSkdITI8eWfack10ceO53ochHxIxpoZ8a0nyuTYveuGTZs2DckjQf1A6cWb+axPlL9b78xBH76idHyRyB6586dW7xmzZorWBcODg7eQUFBiGPFvXv3JsnLy1d///59CPy9cePGzIKCAkI8avzQYmJiDHfv3p2I/bZw4cKL169fpw3vCnHFJkyYUPfixYspampqmYWFhTxt79ixI+LIkSOIW6WGhkZGXl6e7qtXr0ZISko2fvr0aSTcSkePHiXE5IZDasuWLUmtra2Dm5ubJd6+fTtGWFi4fc6cOZUdHR0iGhoauR4eHj25vKHt0tLSpcrKypfh3xMnTnwExALfAm6179+/iwUGBjrp6ekR8lLBu5kzZ1Y3NTXNhnoxMTHGcDPm5eWpaGhoFMNvJ06cUN+6dStlAHp4f+TIkW07duzoIT4FBYUrlZWVS+k+eUNDw1RZWdnazs5OMK+wqqqqZIGgbGxs/MLCwpxFRUW/3bt3T/qXX34hYLpv3bolPX/+/NssFktk1KhRryQkJBqeP38+6enTp9OgLz8/v/0uLi4HyP0uWLDgws2bN1cMGjTo87hx457CjQ5l2tvbRSUlJWuLioq2kgMmktvoIWjUNe2mMXXMZ+opI+ytuNjbAwE71ZYoSkKycIgK3nn6TOVqe4/j+dzAcb1rywEdZrRtdaCXs4ET1puTZ8KB9JxL+/5IQnioC4D9IUMGvB48sP8ndFGIWR7gku/qYgl1d3cRs5L3kZhbWzsGLFGUygoL3GnRxypIMUdHR7fAwEBvrI6Xl5ejh4dHEPxtbm5+IC4urierJt0pDmUhnamUlNTNxsZGOUFBQYC9CykpKRWePXt2A914ysvLFZYuXYp4P4WHh++0traOw5cFgpGSkrqN3ViLFy8uu3r16uqTJ0+u3bRpUwmUTU1N3aSnp0eIyY1vQ0FB4TIQiJyc3I07d+4spBsLtg7i4uK/A0FMmDDhVW/rWFtbKyErK3sXiATKurm5Ofn4+ATu3r07NCYmxlZcXPzTvXv3pOjagtBAs2bNugG3LQSv7+rqYqxYseLMxYsXKX22oY+jR4/qmZmZpWBjO3fu3JI1a9Zc5RwEi+Xl5a9TcSY+Pj62bm5uSPSY8+fPLwQ2OSEhYev27dsz4LeysrJFq1atuo6f89OnT8dISUk1woHu4ODgERQU1LNPelsb/HuEoIF9W7bO4e4bilAy/BpjgrdLdzdDQECgZeSIwW8Bet7NYjPfvfs0mslkcNzO+jYcslM7ZBdU0nC5/fTZb7K8KVN6bxMOGyxFKbE0F0v+ZyNKgKwf7A0pWFfzsFr8RrZw4cLz169fX4WVCQkJ2WNnZxfV3Nw8Tk5Orubr16/D4R04ZlRXV8vKyso2ULV37NgxXVNT07QJEyY0jxgx4vWdO3eWamhonMjLy9Oh69/Pz8/WxcUFNlnXnTt3ZsvJyTXiy969e3fGnDlzajGCwdjRvXv3BkRERDiKi4t/BjYdWE6qPh4+fDheRkamobW1daCNzV7/sLCInrzH5PKLFi0qu3bt2sreuAp8vaioKFNLS8sexauFhcXB6Oho21mzZlXU1tYqKCoqXrpx48YKuvknJSVtNjQ0zB43btyzUaNGfbhz51KR2XUAABGeSURBVI7chg0bck6dOsXDXWJt6OjoHM/IyNiO/Z2VlbVRSUnpyujRo5+3tbUNsLGx8Q8LC+OZ5+rVq4vOnz+//pdffml69OgRePp1GhsbRx8/fnw36Adqamp4wh7hxZ3S0tJlysrK5b3vct4SCEH/MfdG3kbANQwICLvuwWH/j/iAIlE5hw96kpds35NzmBtLWRCffu/PzPG/WgeN5Sz6tjjLFcb6tq+NwwkMcuO3b9+GYnViY2O379q1K3Hv3r2BERERPQnjpk+fXnv//n2QVXmUNXDTyMjIXK+vr1fYv3+/Z01Njfz58+dV9fX1j6akpOygG8/KlStPX7hwYd306dPrOG0TglrFxMRs3717d4+Cbty4cU9u3LghpaGhUVZVVaW4YMGCS8AO0rWfmJiobWRkhGAHCgoKlDZu3Iik/CU/z58/HwssaEtLyxBXV1dnX1/fgL6s4aZNm9JOnjzZk8JWR0cnwc/Pz0lCQuJJR0dHP363GnAfcnJy16qrqxX37dvn09DQIFNaWqrOIVjKIAUQbH/y5Ml1GJsMY4yPj9cbNWrUOzU1NSROGtU8QbEI3/nTp08/4dvPz89XfvLkyVQJCYkmFRWVMvKcOfqUvbDuVVVVPLm3+7JGyGUA/0cXHK73RnpnpdE2yOWIfwPSbJ2yfEJ0qCWSzhOeQ3GnrEMP5YT1zeMLP9K+joludr2PdfVK2YyjEdaE/Mi9rRVoV3V0dApAgykmJtb67du3gZmZmRvWrFlTDtpWFos1EDTfHR0dQoaGhrFJSUm7qdpMTU3V0NPTO9m/f/8vt27dmqujo5NRW1srb2FhERIdHd3jzIKvC5ts1qxZjR8/fhxF17ampmZKbm5uT2bPESNGvMnIyNBQV1c/8/3798H29vZewcHBhBhn+D6MjIxiExMTdw4bNuxtbW2tJFkTjpU9ceLExq1bt+bD37a2tt4LFy6sbG1t7ScgINClo6NzFrTI5Hm/evWqv7y8fP2rV68mY+/U1NROamtrp+vr6yOy9tmzZ5crKSkhcjn5wW6/fv36fa2qqpIzMDBIuX379gJzc/OIuLg4a6o6N27ckFNUVLyNf+ft7W33/v37kYcOHbIfMmTIb3V1dZLjx4//iC9TVFS0WlVVFTnMEhMTdY2MjBA2m9+DF3ckJSXvuLu7e3R2dop2dXUJS0tL18+bN6++tzaw9whBbzbwL6u+28wTPaKvjVCX6zthgfwc6G2yVUdzWQ86bMt2/zNVd5qVyREt/rMx4afdtyTz5P4AtBLqZ6aptXExYtLp62Nubh4Gmwe0vsOHD39dWVm5Elira9euKXp7eweqqKhkXrx4Ua2tra1/enr6Zl1dXUJAAawfeXn5K1VVVYuBMBMTEy3GjBnz7M2bN+MdHR09AwMDKTWkYK7CbpWUlJTN+vr6hLaBYBQUFOpevnz5y9SpU5tevXo1QUhIqB20ymFhYUgWR34EA1zDjBkzqh88eCDDYTfV6NbF1NQ04tixY4R4ZlB2zJgxT6urq6VHjx79nVz34sWLC1asWIGYayQlJesaGxtlFBQUyidNmvQoKytr+6hRo16C/Dx8+PAvVP0qKChcqqysXKarqxufnp5uOnbs2CevXr2aZGtr63/gwAFK0SAwMHCvo6Nj+IABAz4Dm/zgwYPZOjo6R+/fvy8F+oFVq1adLisrUyX3hynMREREWmpra6WBg+htj5DFHXz5yMhI0z179sT31kbPzuaEHa3v6OgawovE6jtREjuku+V42wM5V1RM5ENesoc0FqKUO6bOIagJ7b/59HVsvGOF+NSDB/Z/UXrSc1ZfArZho4YTWFpa+nZDQ8McuAk/ffo0pKysTC02NlbP3d09ZNiwYR/Wrl2bHxER4Qq3SF1dndTUqVOROGr4B+zOW7ZsOYVpXCdPnvxswoQJz+EGpdOcQn1MDqZrG68wc3JyckpNTd3x8uXLSXBYwMYfOXLkr7CRyWYubGyg1Z03bx5kqxDkNw6y4g0/N21t7aSsrKwe/D7+Hdisvby8ggYPHvzR1tbWx93dPQz+LSgo2Pnx48ef1q1bd7K4uJgyAD1OC86urKyUA73D9OnTn3/58mUYXilJXus1a9acOnfunBoo+BYsWHAlJibGHkSsz58/DwSOws/Pb5+Li0sYuR6w9kDwsrKyFTU1NT0ZLfnt4KioKGNLS0seohUSEmqtra2djdnb+0IFTGLgAHIVKoL+bxE52heSR3rujJL04449WRAz8y5r27sezyRnfOB/aMDbPzI2fNm+1YMIKOuVFI5HH6AODke34DU1NdPl5ORA4SQaHh5ump+fv+XSpUtrOFrShb6+vntv3ry5tKioSJOfKQUza6iqqmYXFRVpQ7tz5sypB633oUOHdlhZWfGg9WBM2Caja9vLy8vOw8MjWFhYuA00sCYmJinNzc2S2HzWrl2bd+bMGUJMbvxcw8PDza2trZEUvdeuXVNYtGjRLaq14NxEoKkWtbW19d22bVsGgGg6OjoEZ86c+ZhOJ7F06dIz5eXlyvLy8jcCAwNtV69eTdAQh4aGWuzfvz+Gqs/FixefvXr16holJaX8s2fPajQ3N08BGb67uxu+BY+2H9qA6ChTpkxp+PDhwxhLS8tQSUnJeryJEMpcvXp13uLFi6vwfQIwCMqCwmzv3r1BoEzsCxGqq6un5efn606aNKk5OTlZD4BCnZ2dQmJiYt/l5eUb/ohplBkek+9wMOpkIFW+pL4M5j8tAwHXnPZp7dmFi/ls7xEfnZl7efcfsYn/p+PoS30ImBcZsmu9msoCxO7Z1yc2NtZo165dCYCaunnz5lwzM7PjNTU186D+uHHjHgFIQk1N7cL79+9H79+/3yc0NJSQrBzK4c1HEhISd0G58vr16zEVFRWIHTUpKWmroaFhj8iCjQ3s27Nnz27o6Ojob2dn5xsSEuJGHvfy5cuLL126pCIpKXm3sbERtOs3a2pq5mPlMG083Xw5dm3tCRMmPHz27JkMXRws3E3Eunnz5pwFCxYQUg1TtQ/5rYEAP3/+PNLCwuKAq6tr0Pjx4190dXVB0il4aNsqKChYs3HjxrNQSEJCok5CQqLxzZs3o2/evIkk3Dt27JiBqalpj1kK67+kpGSViooKAhzJy8tbB7qNzZs3n8be080Trxg8efKkyqZNm87AAeLu7u7MYrGEXVxc/GfNmkVAVOLFHSMjozjQQ/R1X1GVY0YdPW0VFJYZgQarIz90NxfX9EOPKOt9WODm2N3d3ZkZ7zAHH9lwr8PhY/mnb5igBN07Yo3Y039nbOTbHks3U3jCdTaWqrX3GaIlMIUTmIIaGhoWTJs2rebhw4cS8C4wMNB6zpw51RjQoqSkZDWVFnTJkiWlV65cUaLrMycnZ8PmzZsLye/x9k+qtoFgAL0GwBETE5Oo+Pj4PcuXLz9z6dIlZU5bCKuqoKBASACH9QOoLxkZmfo3b95M0NLSSsnOzjagGyO2DtOmTat/8OCBbG8gCQ5B9QBHcnNzVTdt2nRh0KBBL79+/ToM3nOQaGAa6omFhvW/bNmy05cvXybkv8aPLSMjY5OOjg6PXR3Y+gMHDriKiop+f/r06eTGxsZpq1atuobVpRMP9PX148DSMHz48Dc1NTVg4vvo6+u939XVPQTaunv3rgxZpr5y5cr8JUuWIPHJkpKStAwNDQmAmr7uMawcEwICmliEXkXDyfaN9aTupLe6vO8hwuW0qT/fKMnxIYAQjiWVGnsGpMQPHiyO66q39vlNvbe6vb1nMH7/9I1hab7BzXnfFt8/ssh4hJaZmVnk0aNHrUaNGvUC4J8A73z37t1kGxsbz/DwcCf4++HDh9JDhgz5Hd9HcXHxynXr1iGmDmNj45iJEye+BGIAWzVmez5z5szKtWvXXiSPDdtkYK9++PChFLlt/M2PKcw4GxYhTCroJr6PCxcuLFq5cuVV+A0zw1GtD/4m2rx5c3J2drbZr7/+OhDKCkAyaiGhtlGjRgFijPBYWFgER0dH2/Xv3/9zQ0ODxKRJk36DG/LFixe/QEF9ff0jKSkp5uR6xcXFy9atW3cJfgcF4qRJk54LCQmxq6urZU6ePIkk6SsqKlqjqqqK3MT4BwOOyMnJXb9z584iwFjPnTv3Llbm8OHDhjt37iSkVWKz2UKcg1pKSkqqury8fHlra6uwqqpqYU1NjSIHdLOc3BemHxAWFm69cOGCooSExOP29nYEPAPPzz///Ds/rDm5PUTLvUHH40Jt/bMVKEqsN+1vb5u/t/fcIXz6/J3h5aRnZmq49hh+YHDqaxoEX3v+4q2MuHjfgwJi4VDpPbv6PjZsPODSCfGvlyyUOpUR76hNBaqn2sDYb3iFEwATtLS0SocOHfry06dPI5ydnV39/f39ZGRkbgEOW1lZ+VRpaelGcnurVq06BUq02bNnAyu8EJOpjh49amBmZpYE5alkOpCtp06devfRo0cz6drGbOBAMKD4AuCIhYVFKIA2oF09Pb1jqamphITt+PG5uLi4+vn5+QgKCrbV1dXNolPg4G8iUM7169evFZRk0Nbnz58HhYeH77aysiIkz4N3HOWSAt4ODgrG+vp6OXhPJ2qsWbOm4Ny5cxtgbWtraxUxbiA5OXmrgYEBYkq6cuXKgiVLlhBihz969GiClJQUyMEDra2tA8LDw50B+CMtLd3U3t4uTjdPqCcpKXmvvb29PxAgKO26urqEvn37hkB5/fz8rF1cXCLI3xYTdwQFBbsHDx78AVuTtrY2sRkzZtRWV1cv6wsng7WLLGhV7SOZ7eYhZd++tY38z27qvrG7QCSfv3xnKK2Uy0yMtaXEK9+uezrTwSUuvenhS1kBJhMFqnBDGHNoluR5hZXBzw4pwgb4Fbc+eInhVpaOzMFhpH8/0Q5VZYVjtpZmduRcyvwIGXvn6urq5Ovr6w9248ePH0+DsLdjxox5MXDgwC9Pnz6d+v79++EzZsy4BzIWsN+Ojo6Ejw6ABLAFQ3vkm8HX13e/q6sr4KTZgD4iI8tAXl+wYAGiuPH397dxdnYOJ49ZUlKyqrGxce78+fPLKyoqENkS1y7ImdtMTU3T6eaKwT2lpaXv1NfXz6Ur5+rq6uLr60vL3dy4cWOuoqIiwId7Hrw5x97e3jM4OBgxy3Egm8rAxtbU1EjPnDnzKb4enqM5dOiQCf6g8Pf3t3Z2dka00xUVFbLz58/vuXnht4SEBN3t27enwb8x4Mjvv/8+ZOrUqfc+fPgwWkZGpgrgo+R5wiUkLy9f9ezZs+nkdyoqKrnFxcU6ZKcWABsBuu7r1689YCN8XV1d3YT09PQebEZf9htC0BhRe/omH6lvfLqgm8VG9j8/Aw+HTHAh1on3ItYw+b4HIhEXF2vXWL8w2t/DyIVfIHHIgVR+84pK04OX81gsNmRd64196HXOcAKKiAh2CAkJdTDZTCSPJ5sJNwVqHkMTe8LsWayRwwa/XDB35mVJyfGIm96febKzs1Vv3LixcNq0aQ8AFQYfPiIiwgpA/yDzgtIqKSnJEAAn5ubmiWRoZXZ2tsr58+eVRo4c+cbS0jIKb6cFtrKwsHADsNF2dnaRZLMS4J/T0tJ0wN3QyMgocdq0aT2paZHvx2aLBgQE7AJuYenSpZcw9rOiomJ2Xl6epqioaIuZmdlROpAIsJmhoaE73717N3rhwoXX1dXVaZWFAL2srKxUEBMTI+RuhltsxIgRb11dXaPIGx5bGzBd6ujopMrIyDyCcWdmZqpXVVXNmzBhwmMqGy3Y3YuKilRGjBjxztraOhKv8wDHkPz8/I0DBw785OzsHEUWQeB9WVmZ0qBBgz6am5sfhboAQ46IiAARYcLixYuvbNy4ETlgyQ84c+Tk5Gh8/vx5MLwTFhbukJOTq9bW1oY44wQPNXgPqLmDBw/uhvmR9zaw3Vu2bMlasmQJAdzS2x7sIWjOBxa+eKV6YW398wUtbe0DBBj0fqK9NYx/DwQChMJisAVGjBj86/IFM89Onz7x8R9p49+y/67AvyvQ+wr8PwbKfsXCD8mRAAAAAElFTkSuQmCC";
    const mainpdf = (
      <html lang="en">
        <head>
          <meta charset="utf-8" />
          <link rel="icon" href="/" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="theme-color" content="#000000" />
          <meta
            name="description"
            content="Web site created using create-react-app"
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Quattrocento:wght@400;700&display=swap"
            rel="stylesheet"
          />
        </head>
        <body>
          <table
            style={{
              width: "700px",
              margin: "0 auto",
              border: "10px solid rgb(0, 74, 173)",
            }}
          >
            <tbody style={{ width: "100%" }}>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      margin: "0 auto",
                      width: "250px",
                      paddingTop: "50px",
                    }}
                  >
                    <img style={{ width: "100%" }} src={imgBase64} alt="logo" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h1
                    style={{
                      color: "rgb(0, 74, 173)",
                      fontSize: "35px",
                      textAlign: "center",
                      padding: "0px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    Certificate of Training
                  </h1>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "20px",
                      textAlign: "center",
                      padding: "5px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    This is to certify that
                  </h2>
                </td>
              </tr>
              <tr>
                <td>
                  <div style={{ borderBottom: "2px solid #d6d6d6" }}>
                    <h3
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "35px",
                        textAlign: "center",
                        margin: "12px 0px",
                        fontFamily: '"Great Vibes", cursive',
                      }}
                    >
                      {name_9}
                    </h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      marginTop: "30px",
                      fontSize: "20px",
                      textAlign: "center",
                      padding: "5px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    has successfully completed training in
                  </h2>
                </td>
              </tr>
              <tr>
                <td>
                  <div style={{ borderBottom: "2px solid #d6d6d6" }}>
                    <h3
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "12px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      Health & Safety Awareness
                    </h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div
                    style={{
                      borderBottom: "2px solid #d6d6d6",
                      padding: "30px 0px",
                      marginTop: "30px",
                    }}
                  >
                    <h5
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "0px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      undertaken on the date
                    </h5>
                    <h6
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "0px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      {formatDate_notes()}
                    </h6>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "20px",
                      textAlign: "center",
                      paddingTop: "40px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    Delivered by:
                  </h2>
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      margin: "0 auto",
                      width: "250px",
                      paddingBottom: "20px",
                    }}
                  >
                    <img style={{ width: "100%" }} src={imgBase64} alt="logo" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </body>
      </html>
    );
    const filenamee = "Health & Safety Awareness";
    generatePDF(mainpdf, filenamee);
  };
  const downloadpdf = () => {
    const userStr = JSON.parse(localStorage.getItem("users"));

    let formdata = {
      user_id: userStr[0].id,
      id: id,
      name: name_9,
    };
    console.log(formdata);
    //setscoreCard(1);

    axios
      .post("https://jlmining.app/coursepdf", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => { })
      .catch((err) => { });
    pdfdataget();
  };
  //Pdf
  const handlegalTab = (event) => {
    if (event === "legal") {
      if (!stepl_1.includes("legal")) {
        setstepl_1((prevState) => [...prevState, "legal"]);
      }
      setactiveTablegal(!activeTablegal);
    }
    if (event === "morel") {
      if (!stepl_1.includes("morel")) {
        setstepl_1((prevState) => [...prevState, "morel"]);
      }
      setactiveTabmorel(!activeTabmorel);
    }
    if (event === "finanical") {
      if (!stepl_1.includes("finanical")) {
        setstepl_1((prevState) => [...prevState, "finanical"]);
      }
      setactiveTabfinanical(!activeTabfinanical);
    }
  };
  const stepformlesson = (event) => {
    if (event === "Step1") {
      console.log(stepbutton11);

      setactiveStepsecond(true);

      setstepbutton2(true);
      setTimeout(() => {
        stepSecond.current.scrollIntoView({ behavior: "smooth" });
        setStrokeDashArray_less1(249.36);
      }, 100);
      setstepbutton11(false);
    }
    if (event === "Step2") {
      setactiveStepthird(true);
      setstepbutton2(false);
      setstepbutton3(true);
      setTimeout(() => {
        stepThird.current.scrollIntoView({ behavior: "smooth" });
        setStrokeDashArray_less1(312.36);
      }, 100);
    }
    if (event === "Step3") {
      setactiveStepforth(true);
      setstepbutton3(false);

      setStrokeDashArray_less1(365.36);
      setTimeout(() => {
        stepForth.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "Step4") {
      setistruefalse_1(true);

      const stepsArray = [
        {
          Lesson_Step2: {
            Step2: "2",
            Step1_Icon: "365.36",
          },
        },
      ];
      localStorage.setItem("LessonStep", JSON.stringify(stepsArray));
      setlesson2(true);
      setlesson1(false);
      setleftmenu_bar(11.11);
      setbarwidth(11.11);
      setTimeout(() => {
        second.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };
  // Lesson 2 Start
  var settings_cro = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const stepformlesson2 = (event) => {
    if (event === "Step1") {
      setstep2active(true);
      setstep1active(false);
      setstep2activeBtn(true);
      setStrokeDashArray_less2(249.36);
      setTimeout(() => {
        stepTwo.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "Step2") {
      setstep2activeBtn(false);
      setstep3active(true);
      setStrokeDashArray_less2(312.36);
      setTimeout(() => {
        stepTwo_2.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "Step3") {
      setstep4active(true);
      setstep3active(false);
      setStrokeDashArray_less2(365.36);
      setTimeout(() => {
        stepTwo_3.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "Step4") {
      setlesson2(false);
      setlesson3(true);
      setistruefalse_2(true);

      //var lsteps = "Lesson_Step2";
      //localStorage.setItem("LessonStep", JSON.stringify(lsteps));
      //navigate(`/lesson3/${isCourse.slug}/${unicode}`);
      setleftmenu_bar(22.22);
      setbarwidth(22.22);
      setTimeout(() => {
        third.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };
  // Lesson 2 End

  //Lesson 3 Start
  const stepformlesson3 = (event) => {
    if (event === "Step1") {
      setstep3btn_1(false);
      setstep3btn_2(true);
      setstep3section2(true);
      setStrokeDashArray_less3(249.36);
    }
    if (event === "Step2") {
      setstep3section3(true);
      setstep3btn_2(false);
      setStrokeDashArray_less3(312.36);
    }
    if (event === "Step3") {
      setstep3section4(true);
      setstep3btn_3(false);
      setStrokeDashArray_less3(365.36);
    }
    if (event === "Step4") {
      setistruefalse_3(true);
      setlesson3(false);
      setlesson4(true);
      //var lsteps = "Lesson_Step3";
      //localStorage.setItem("LessonStep", JSON.stringify(lsteps));
      // navigate(`/lesson4/${isCourse.slug}/${unicode}`);
      setleftmenu_bar(33.33);
      setbarwidth(33.33);
      setTimeout(() => {
        forth.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };
  const tabSection = (event) => {
    setnewtab(event);
    if (event === "1") {
      if (!istabSection.includes("1")) {
        setistabSection((prevState) => [...prevState, "1"]);
      }
    }
    if (event === "2") {
      if (!istabSection.includes("2")) {
        setistabSection((prevState) => [...prevState, "2"]);
      }
    }
    if (event === "3") {
      if (!istabSection.includes("3")) {
        setistabSection((prevState) => [...prevState, "3"]);
      }
    }
  };
  //Lesson 3 End

  //Lesson 4 Start
  const tabReview = (event) => {
    if (!istabreview.includes(event)) {
      setistabreview((prevState) => [...prevState, event]);
    }
    settabsectionView(event);
  };
  const stepformlesson4 = (event) => {
    setistruefalse_4(true);
    setlesson4(false);
    setlesson5(true);
    setleftmenu_bar(44.44);
    setbarwidth(44.44);
    setTimeout(() => {
      fifth.current.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };
  //Lesson 4 End

  //Lesson 5 Start
  const startQuiz = () => {
    setquizmain_Section(true);
    setstartQuiz(false);
    setsection5_quiz1(true);
  };

  const Quiz_check = (event) => {
    if (event === "1") {
      setcheckQ_1("");
      setQuizAns_1_btn("blue");
      setQuizAns_1(issetQuizAns_1_btn);
      if (issetQuizAns_1_btn === "blue") {
        setrightansQuiz_1(true);
      } else {
        setworngansQuiz_1(true);
      }
      setfirstquiz(true);
      setfirstnext(true);
      setfirstsub(false);
      setTimeout(() => {
        q1.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "2") {
      console.log(issetQuizAns_2_btn);

      setcheckQ_2("");
      setQuizAns_2_btn("No");
      if (issetQuizAns_2_btn === "No") {
        setrightansQuiz_2(true);
      } else {
        setworngansQuiz_2(true);
      }
      setissecondquiz(true);
      setsecondnext(true);
      setsecondsub(false);
      setTimeout(() => {
        q2.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }

    if (event === "3") {
      setcheckQ_3("");
      setQuizAns_3_btn("No");
      if (issetQuizAns_3_btn === "No") {
        setrightansQuiz_3(true);
      } else {
        setworngansQuiz_3(true);
      }
      setisthirdquiz(true);
      setthirdnext(true);
      setthirdsub(false);
      setTimeout(() => {
        q3.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "4") {
      setcheckQ_4("");
      setQuizAns_4_btn("Provision_of_a_work_vehicle_to_purchase_lunch");
      if (
        issetQuizAns_4_btn === "Provision_of_a_work_vehicle_to_purchase_lunch"
      ) {
        setrightansQuiz_4(true);
      } else {
        setworngansQuiz_4(true);
      }
      setisforthquiz(true);
      setforthnext(true);
      setforthsub(false);
      setStrokeDashArray_less5(365.36);
      setTimeout(() => {
        q4.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };
  const Quiz_next = (event) => {
    if (event === "1") {
      setsection5_quiz2(true);
      setsection5_quiz1(false);
      setStrokeDashArray_less5(249.36);
    }
    if (event === "2") {
      setsection5_quiz2(false);
      setsection5_quiz3(true);
      setStrokeDashArray_less5(290.36);
    }
    if (event === "3") {
      setsection5_quiz3(false);
      setsection5_quiz4(true);
      setStrokeDashArray_less5(312.36);
    }
    if (event === "4") {
      setsection5_quiz4(false);
      setistruefalse_5(true);
      setquiz5_result_section(true);
      if (userChooseAns_1 === "blue") {
        var mainresult_1 = 25;
        var per_1 = 31.25;
      } else {
        var mainresult_1 = 0;
        var per_1 = 0;
      }
      if (userChooseAns_2 === "No") {
        var mainresult_2 = 25;
        var per_2 = 31.25;
      } else {
        var mainresult_2 = 0;
        var per_2 = 0;
      }
      if (userChooseAns_3 === "No") {
        var mainresult_3 = 25;
        var per_3 = 31.25;
      } else {
        var mainresult_3 = 0;
        var per_3 = 0;
      }
      if (userChooseAns_4 === "Provision_of_a_work_vehicle_to_purchase_lunch") {
        var mainresult_4 = 25;
        var per_4 = 31.25;
      } else {
        var mainresult_4 = 0;
        var per_4 = 0;
      }
      const total =
        mainresult_1 + mainresult_2 + mainresult_3 + mainresult_4 + "%";
      const total_per = per_1 + per_2 + per_3 + per_4;
      if (total_per === 0) {
        var t_p = 107 + "%";
        setstroke_5("");
      } else {
        var t_p = 220 + total_per + "%";
      }
      setisresult(total);
      setfinalperc(t_p);
      console.log(t_p);
      setleftmenu_bar(55.55);
      setbarwidth(55.55);
    }
  };
  const restart_lesson5 = () => {
    setlesson5(true);
    setlesson6(false);
    setstartQuiz(true);
    // Q1
    setstartQuiz(true);
    setquizmain_Section(false);
    setsection5_quiz1(true);
    setsection5_quiz2(false);
    setsection5_quiz3(false);
    setsection5_quiz4(false);
    setQuizAns_1("");
    setQuizAns_1_btn("");
    setfirstquiz("");
    setworngansQuiz_1(false);
    setrightansQuiz_1(false);
    setcheckQ_1("");
    setfirstnext(false);
    setfirstsub(false);

    // Q2
    setistruefalse_5(false);
    setworngansQuiz_2(false);
    setrightansQuiz_2(false);
    setsecondsub(false);
    setsecondnext(false);
    setcheckQ_2("");
    setQuizAns_2_btn("");
    setissecondquiz("");

    // Q3
    setcheckQ_3("");
    setisthirdquiz("");
    setQuizAns_3_btn("");
    setworngansQuiz_3(false);
    setrightansQuiz_3(false);
    setthirdsub(false);
    setthirdnext(false);

    // Q4
    setisforthquiz("");
    setrightansQuiz_4(false);
    setforthsub(false);
    setforthnext(false);
    setworngansQuiz_4(false);
    setcheckQ_4("");
    setQuizAns_4_btn("");
    setquiz5_result_section(false);
  };
  const startQuiz_1 = (event) => {
    setQuizAns_1_btn(event);
    setQuizAns_1(event);
    setcheckQ_1(event);
    setuserChooseAns_1(event);
    setfirstsub(true);
  };
  const startQuiz_2 = (event) => {
    setsecondsub(true);
    setcheckQ_2(event);
    setQuizAns_2_btn(event);
    setuserChooseAns_2(event);
  };
  const startQuiz_3 = (event) => {
    setthirdsub(true);
    setcheckQ_3(event);
    setQuizAns_3_btn(event);
    setuserChooseAns_3(event);
  };
  const startQuiz_4 = (event) => {
    setforthsub(true);
    setcheckQ_4(event);
    setQuizAns_4_btn(event);
    setuserChooseAns_4(event);
  };
  //Lesson 5 End

  //Lesson 6 Start
  const step6_1 = (event) => {
    if (!istab_6.includes(event)) {
      setistab_6((prevState) => [...prevState, event]);
    }
    if (event === "1") {
      setisFlipped6(!isFlipped6);
      setstrokeDashArray_less6(300.36);
    }
    if (event === "2") {
      setisFlipped6_1(!isFlipped6_1);
      setstrokeDashArray_less6(365.36);
    }
    console.log(istabSection.length);
    // if (istabSection.length === 2) {
    //   setTimeout(() => {
    //     scl_6_1.current.scrollIntoView({ behavior: "smooth" });
    //   }, 100);
    // }
  };
  const step6_btn_1 = () => {
    setstep6_btn1(false);
    setsection6_1(false);
    setsection6_2(true);
    setTimeout(() => {
      scl_6_2.current.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };
  const step6_btn_2 = () => {
    setsection6_2(false);
    setsection6_3(true);
    setTimeout(() => {
      scl_6_3.current.scrollIntoView({ behavior: "smooth" });
    }, 100);
    setstrokeDashArray_less6(458.36);
  };
  const step6_btn_3 = () => {
    setistruefalse_6(true);
    setlesson7(true);
    setlesson6(false);
    setleftmenu_bar(67);
    setbarwidth(67);
    setTimeout(() => {
      seven.current.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };
  //Lesson 6 End

  //Lesson 7 Start
  const step_btn_7 = () => {
    setistruefalse_7(true);
    setlesson7(false);
    setlesson8(true);
    setleftmenu_bar(77);
    setbarwidth(77);
  };
  const NextArrow = ({ onClick }) => (
    <button type="button" onClick={onClick} className="slick-next">
      {/* Your custom next arrow icon or text */}
    </button>
  );

  const PrevArrow = ({ onClick }) => (
    <button type="button" onClick={onClick} className="slick-prev">
      {/* Your custom previous arrow icon or text */}
    </button>
  );
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (slide) => setCurrentSlide(slide),
  };
  const setCurrentSlide = () => {
    setClickCount((prevCount) => prevCount + 1);
    if (clickCount === 1) {
      setstrokeDashArray_less7(300.36);
    }
    if (clickCount === 2) {
      setstrokeDashArray_less7(365.36);
    }
    if (clickCount === 3) {
      setstrokeDashArray_less7(400.36);
    }

    if (clickCount >= 4) {
      setbtn7(true);
      setstrokeDashArray_less7(458.36);
    }
  };
  //Lesson 7 End

  //Lesson 8 Start
  const btn_8 = () => {
    setsect_8(true);
    setsect_8_1(false);
    setstrokeDashArray_less8(458.36);
  };
  const btn_8_2 = () => {
    setistruefalse_8(true);
    setlesson8(false);
    setlesson9(true);
    setleftmenu_bar(85);
    setbarwidth(85);
  };
  //Lesson 8 End

  //Lesson 9 Start
  const btn_entername = () => {
    if (name_9 !== "") {
      setless_9_q_1(true);
      setstq(false);
    }
  };
  const entername_9 = (event) => {
    const trimmedValue = event.target.value.trim();
    if (trimmedValue === "") {
      setname_9(false);
    } else {
      setname_9(trimmedValue);
    }
  };
  const startQuiz9_1 = (event) => {
    setcheckQ_9_1(event);
  };
  const startQuiz9_2 = (event) => {
    setcheckQ_9_2(event);
  };
  const startQuiz9_3 = (event) => {
    setcheckQ_9_3(event);
  };
  const startQuiz9_4 = (event) => {
    setcheckQ_9_4(event);
  };
  const startQuiz9_5 = (event) => {
    setcheckQ_9_5(event);
  };
  const startQuiz9_6 = (event) => {
    setcheckQ_9_6(event);
  };
  const startQuiz9_7 = (event) => {
    setcheckQ_9_7(event);
  };
  const roundNumber = (num) => {
    return Math.round(num);
  };
  const quiz1_checkbtn = (event) => {
    var c_1 = 0;
    var c_2 = 0;
    var c_3 = 0;
    var c_4 = 0;
    var c_5 = 0;
    var c_6 = 0;
    var c_7 = 0;
    if (event === "1") {
      if (checkQ_9_1 === false) {
        setquiz_dia(true);
        setinvalidAns("Invalid Answer");
        setquestans("You must complete the queston before submitting");
      }
      if (checkQ_9_1 !== false) {
        setquiz_dia(true);
        if (checkQ_9_1 === "Legal_moral_and_financial") {
          var c_1 = roundNumber(14.285714286);
          const newValue = 20;
          setMyArray((prevArray) => [...prevArray, newValue]);
          setMyArray_s((prevArray) => [...prevArray, 8]);
          setinvalidAns("Correct");
          setquestans("That's right! You selected the correct response.");
        } else {
          setinvalidAns("Incorrect");
          setquestans("You did not select the correct response");
        }
      }
    }
    if (event === "2") {
      if (checkQ_9_2 === false) {
        setquiz_dia(true);
        setinvalidAns("Invalid Answer");
        setquestans("You must complete the queston before submitting");
      }
      if (checkQ_9_2 !== false) {
        setquiz_dia(true);
        if (checkQ_9_2 === "Vehicle_collisions") {
          var c_2 = roundNumber(14.285714286);
          const newValue = 20;
          setMyArray((prevArray) => [...prevArray, newValue]);
          setMyArray_s((prevArray) => [...prevArray, 8]);
          setinvalidAns("Correct");
          setquestans("That's right! You selected the correct response.");
        } else {
          setinvalidAns("Incorrect");
          setquestans("You did not select the correct response");
        }
      }
    }
    if (event === "3") {
      if (checkQ_9_3 === false) {
        setquiz_dia(true);
        setinvalidAns("Invalid Answer");
        setquestans("You must complete the queston before submitting");
      }
      if (checkQ_9_3 !== false) {
        setquiz_dia(true);
        if (checkQ_9_3 === "All_of_the_above") {
          var c_3 = roundNumber(14.285714286);
          const newValue = 20;
          setMyArray((prevArray) => [...prevArray, newValue]);
          setMyArray_s((prevArray) => [...prevArray, 8]);
          setinvalidAns("Correct");
          setquestans("That's right! You selected the correct response.");
        } else {
          setinvalidAns("Incorrect");
          setquestans("You did not select the correct response");
        }
      }
    }
    if (event === "4") {
      if (checkQ_9_4 === false) {
        setquiz_dia(true);
        setinvalidAns("Invalid Answer");
        setquestans("You must complete the queston before submitting");
      }
      if (checkQ_9_4 !== false) {
        setquiz_dia(true);
        if (checkQ_9_4 === "All_of_the_above") {
          var c_4 = roundNumber(14.285714286);
          const newValue = 20;
          setMyArray((prevArray) => [...prevArray, newValue]);
          setMyArray_s((prevArray) => [...prevArray, 8]);
          setinvalidAns("Correct");
          setquestans("That's right! You selected the correct response.");
        } else {
          setinvalidAns("Incorrect");
          setquestans("You did not select the correct response");
        }
      }
    }
    if (event === "5") {
      if (checkQ_9_5 === false) {
        setquiz_dia(true);
        setinvalidAns("Invalid Answer");
        setquestans("You must complete the queston before submitting");
      }
      if (checkQ_9_5 !== false) {
        setquiz_dia(true);
        if (checkQ_9_5 === "Everyone") {
          var c_5 = roundNumber(14.285714286);
          const newValue = 20;
          setMyArray((prevArray) => [...prevArray, newValue]);
          setMyArray_s((prevArray) => [...prevArray, 8]);
          setinvalidAns("Correct");
          setquestans("That's right! You selected the correct response.");
        } else {
          setinvalidAns("Incorrect");
          setquestans("You did not select the correct response");
        }
      }
      setbarwidth(100);
      setleftmenu_bar(100);
    }
    if (event === "6") {
      if (checkQ_9_6 === false) {
        setquiz_dia(true);
        setinvalidAns("Invalid Answer");
        setquestans("You must complete the queston before submitting");
      }
      if (checkQ_9_6 !== false) {
        setquiz_dia(true);
        if (checkQ_9_6 === "The_local_council") {
          var c_6 = roundNumber(14.285714286);
          const newValue = c_6;
          setMyArray((prevArray) => [...prevArray, newValue]);
          setMyArray_s((prevArray) => [...prevArray, 5.714285714]);
          setinvalidAns("Correct");
          setquestans("That's right! You selected the correct response.");
        } else {
          setinvalidAns("Incorrect");
          setquestans("You did not select the correct response");
        }
      }
    }
    if (event === "7") {
      if (checkQ_9_7 === false) {
        setquiz_dia(true);
        setinvalidAns("Invalid Answer");
        setquestans("You must complete the queston before submitting");
      }
      if (checkQ_9_7 !== false) {
        setquiz_dia(true);
        if (checkQ_9_7 === "Individual_job_and_organisation") {
          var c_7 = roundNumber(14.285714286);
          const newValue = c_7;
          setMyArray((prevArray) => [...prevArray, newValue]);
          setMyArray_s((prevArray) => [...prevArray, 5.714285714]);
          setinvalidAns("Correct");
          setquestans("That's right! You selected the correct response.");
        } else {
          setinvalidAns("Incorrect");
          setquestans("You did not select the correct response");
        }
      }

      setbarwidth(100);
      setleftmenu_bar(100);
    }
  };

  const closedia = (event) => {
    if (event === "1") {
      setsectbtn("2");
      setless_9_q_1(false);
      setless_9_q_2(true);
    }
    if (event === "2") {
      setsectbtn("3");
      setless_9_q_2(false);
      setless_9_q_3(true);
    }
    if (event === "3") {
      setsectbtn("4");
      setless_9_q_3(false);
      setless_9_q_4(true);
    }
    if (event === "4") {
      setsectbtn("5");
      setless_9_q_4(false);
      setless_9_q_5(true);
    }
    if (event === "5") {
      setsectbtn("6");
      setless_9_q_5(false);
      setless_9_q_6(true);
      setless_9_result(true);
      const sum = myArray.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      const sum_s = myArray_s.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      setscore_s(sum_s);
      setscore(sum);
      if (sum >= 80) {
        setcorrScore(true);
      }
    }
    if (event === "6") {
      setsectbtn("7");
      setless_9_q_6(false);
      setless_9_q_7(true);
    }
    if (event === "7") {
      setless_9_q_7(false);
      setless_9_result(true);
      const sum = myArray.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      const sum_s = myArray_s.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      setscore_s(sum_s);
      setscore(sum);
      if (sum >= 80) {
        setcorrScore(true);
      }
    }

    setquiz_dia(false);
  };
  const quiz_dia_close = () => {
    setquiz_dia(false);
  };
  const retryButton = () => {
    setistruefalse_9(false);
    setstrokeDashArray_less9("");
    setless_9_q_1(false);
    setless_9_q_2(false);
    setless_9_q_3(false);
    setless_9_q_4(false);
    setless_9_q_5(false);
    setless_9_q_6(false);
    setless_9_q_7(false);
    setless_9_result(false);
    setname_9("");
    setcheckQ_9_1(false);
    setisfirstquiz_9_1(false);
    setissetQuizAns_1_btn_9(false);
    setquiz_dia(false);
    setinvalidAns("");
    setquestans("");
    setsectbtn("1");
    setcheckQ_9_2(false);
    setcheckQ_9_3(false);
    setcheckQ_9_4(false);
    setcheckQ_9_5(false);
    setcheckQ_9_6(false);
    setcheckQ_9_7(false);
    setpassingscore("");
    setcorrScore(false);
    setscore("");
    setMyArray([]);
    setstq(true);
    //inputRef.current.value = "";
  };
  //Lesson 9 End
  //For All Lesson
  const lessonInstruction = (event) => {
    if (event === "1") {
      setlesson2(false);
      setlesson1(true);
    }
    if (event === "2") {
      setlesson2(true);
      setlesson3(false);
    }
    if (event === "3") {
      setlesson3(true);
      setlesson4(false);
      setstep3btn_3(false);
    }
    if (event === "4") {
      setlesson4(true);
      setlesson5(false);
    }
    if (event === "5") {
      setlesson5(true);
      setlesson6(false);
      setstartQuiz(true);
      // Q1
      setstartQuiz(true);
      setquizmain_Section(false);
      setsection5_quiz1(true);
      setsection5_quiz2(false);
      setsection5_quiz3(false);
      setsection5_quiz4(false);
      setQuizAns_1("");
      setQuizAns_1_btn("");
      setfirstquiz("");
      setworngansQuiz_1(false);
      setrightansQuiz_1(false);
      setcheckQ_1("");
      setfirstnext(false);
      setfirstsub(false);

      // Q2
      setistruefalse_5(false);
      setworngansQuiz_2(false);
      setrightansQuiz_2(false);
      setsecondsub(false);
      setsecondnext(false);
      setcheckQ_2("");
      setQuizAns_2_btn("");
      setissecondquiz("");

      // Q3
      setcheckQ_3("");
      setisthirdquiz("");
      setQuizAns_3_btn("");
      setworngansQuiz_3(false);
      setrightansQuiz_3(false);
      setthirdsub(false);
      setthirdnext(false);

      // Q4
      setisforthquiz("");
      setrightansQuiz_4(false);
      setforthsub(false);
      setforthnext(false);
      setworngansQuiz_4(false);
      setcheckQ_4("");
      setQuizAns_4_btn("");
    }
    if (event === "6") {
      setlesson5(false);
      setlesson6(true);
      setTimeout(() => {
        sixth.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "6_6") {
      setlesson6(true);
      setlesson7(false);
    }
    if (event === "7_7") {
      setlesson6(false);
      setlesson7(true);
    }
    if (event === "8_8") {
      setlesson9(false);
      setlesson8(true);
    }
  };
  //For All Lesson
  const menubars = () => {
    setcloseBox(!closeBox);
  };

  return (
    <>
      <div
        className={`d-flex main-admin-block align-items-stretch mt-4 ${closeBox ? "" : "close-box"
          }`}
      >
        <div className="flex-shrink-0 side-layer">
          <div className="scroll-height">
            <div className="d-flex flex-column">
              <div className="top-title d-flex flex-column gap-5">
                <h1>
                  Health & Safety
                  <br />
                  Awareness
                </h1>
                <div className="d-flex flex-column gap-1">
                  <div className="progress-bar-full">
                    <div style={{ width: `${barwidth}%` }}></div>
                  </div>
                  <h4 className="pro-number">
                    <span>{leftmenu_bar}%</span> COMPLETE
                  </h4>
                </div>
              </div>

              <div className="d-flex flex-column side-navbar mt-4">
                <Link
                  to="javascript:void(0)"
                  className="d-flex align-items-center gap-3 list-link anilink active"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Inroduction</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_1 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_1 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less1 }}
                            className="progress two lessonNum_1"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Laws</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_2 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_2 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less2 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Human Aspects</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_3 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_3 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less3 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Safety Signs</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_4 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_4 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less4 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Quiz at Mid-Point</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_5 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_5 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less5 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Workplace Incidents</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_6 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_6 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less6 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>How to Report an Injury</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_7 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_7 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less7 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Some Common Workplace Hazards</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_8 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_8 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less8 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Final Assessment</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      <svg>
                        <circle className="bg" cx="40" cy="40" r="37"></circle>
                        <circle
                          className="progress two"
                          cx="40"
                          cy="40"
                          r="37"
                        ></circle>
                      </svg>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-grow-1 rightpart">
          {lesson1 && (
            <section id="introd" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  to={`/start-course/${id}`}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>home</h5>
                </Link>
                <div className="stop">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 1 of 9</h4>
                      <h1>Introduction</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 py-3 py-md-5">
                      <h2 className="padding">
                        What are the reasons for adhering to health and safety
                        guidelines?
                      </h2>
                      <div className="row intro-img gy-3">
                        <div className="col-lg-4 h-100 position-relative">
                          <img
                            className="object-fit-cover h-100 w-100"
                            src={require("../assets/ohs/images/law4.webp")}
                            alt="img"
                          />
                        </div>
                        <div className="col-lg-4 h-100 position-relative">
                          <img
                            className="object-fit-cover w-100 h-100"
                            src={require("../assets/ohs/images/j2.jpg")}
                            alt="img"
                          />
                        </div>
                        <div className="col-lg-4 h-100 position-relative">
                          <img
                            className="object-fit-cover h-100 w-100"
                            src={require("../assets/ohs/images/j3-d.jpg")}
                            alt="img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-column padding py-3 py-md-5 introdu">
                      <div className="accordion" id="accordionExample">
                        <div className="accordion-item rounded-0">
                          <h2 className="accordion-header" id="headingTwo">
                            <button
                              className="accordion-button rounded-0 collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                              onClick={() => handlegalTab("legal")}
                            >
                              Legal
                            </button>
                          </h2>
                          {activeTablegal && (
                            <div
                              id="collapseTwo"
                              className="`accordion-collapse collapse show"
                              aria-labelledby="headingTwo"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body d-flex gap-3 flex-column">
                                <div className="d-flex flex-column gap-3">
                                  <p>
                                    Legal obligations under health and safety
                                    legislation encompass various entities:
                                  </p>
                                  <ul className="d-flex flex-column gap-3">
                                    <li>
                                      <p>
                                        Persons conducting a business or
                                        undertaking (PCBUs), also known as
                                        employers in Victoria.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Designers, manufacturers, importers,
                                        suppliers, and installers of plant,
                                        substances, or structures.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Workers, including employees,
                                        contractors, sub-contractors,
                                        volunteers, and work-experience
                                        students.
                                      </p>
                                    </li>
                                    <li>
                                      <p>Officers such as company directors.</p>
                                    </li>
                                    <li>
                                      <p>
                                        Others present at the workplace,
                                        including visitors and members of the
                                        public affected by the activities of the
                                        PCBUs.
                                      </p>
                                    </li>
                                  </ul>
                                </div>
                                <div className="d-flex flex-column gap-3">
                                  <p>
                                    In Victoria, duty holders under health and
                                    safety legislation, including:
                                  </p>
                                  <ul className="d-flex flex-column gap-3">
                                    <li>
                                      <p>
                                        Designers, manufacturers, importers,
                                        suppliers, and installers of plant and
                                        substances.
                                      </p>
                                    </li>
                                    <li>
                                      <p>Employees.</p>
                                    </li>
                                    <li>
                                      <p>
                                        Others present at the workplace,
                                        including visitors and members of the
                                        public affected by the employer's
                                        activities.
                                      </p>
                                    </li>
                                  </ul>
                                </div>
                                <div className="d-flex flex-column gap-3">
                                  <p>
                                    Failure to adhere to these obligations may
                                    result in consequences such as:
                                  </p>
                                  <ul className="d-flex flex-column gap-3">
                                    <li>
                                      <p>
                                        Enforcement notices, including
                                        improvement notices and prohibition
                                        notices.
                                      </p>
                                    </li>
                                    <li>
                                      <p>Prosecution, leading to fines.</p>
                                    </li>
                                    <li>
                                      <p>
                                        On-the-spot fines (penalty notices).
                                      </p>
                                    </li>
                                    <li>
                                      <p>Imprisonment of officers.</p>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="accordion-item rounded-0">
                          <h2 className="accordion-header" id="headingThree">
                            <button
                              className="accordion-button rounded-0 collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseThree"
                              aria-expanded="false"
                              aria-controls="collapseThree"
                              onClick={() => handlegalTab("morel")}
                            >
                              Morel
                            </button>
                          </h2>
                          {activeTabmorel && (
                            <div
                              id="collapseThree"
                              className="accordion-collapse collapse show"
                              aria-labelledby="headingThree"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">
                                <p>
                                  Every PCBU bears a moral responsibility to
                                  ensure the safety of workers throughout their
                                  work activities. There's an inherent
                                  expectation that workers should return home to
                                  their families in the same condition they were
                                  in when they left for work. While we can
                                  quantify the tangible costs of workplace
                                  injuries and illnesses, the emotional toll and
                                  loss of a loved one due to a job-related
                                  incident are immeasurable.
                                </p>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="accordion-item rounded-0">
                          <h2 className="accordion-header" id="headingone">
                            <button
                              className="accordion-button rounded-0 collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseone"
                              aria-expanded="false"
                              aria-controls="collapseone"
                              onClick={() => handlegalTab("finanical")}
                            >
                              Finanical
                            </button>
                          </h2>
                          {activeTabfinanical && (
                            <div
                              id="collapseone"
                              className="accordion-collapse collapse show"
                              aria-labelledby="headingone"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">
                                <div className="d-flex flex-column gap-3">
                                  <p>
                                    Experiencing an incident at work can result
                                    in various financial implications,
                                    including:
                                  </p>
                                  <ul className="d-flex flex-column gap-3">
                                    <li>
                                      <p>Loss of production.</p>
                                    </li>
                                    <li>
                                      <p>Damage to plant or equipment.</p>
                                    </li>
                                    <li>
                                      <p>
                                        Costs associated with retraining and
                                        recruitment.
                                      </p>
                                    </li>
                                    <li>
                                      <p>Increased insurance premiums.</p>
                                    </li>
                                    <li>
                                      <p>
                                        Financial penalties imposed by
                                        regulators.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Harm to reputation or loss of business.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Expenses related to prosecution and
                                        legal fees.
                                      </p>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {stepbutton11 && (
                      <div className="d-block padding btn-block text-center mb-2">
                        <button
                          type="button"
                          onClick={() => stepformlesson("Step1")}
                        >
                          CONTINUE
                        </button>
                      </div>
                    )}
                    {activetab1cont && (
                      <div className="d-block padding py-5 mb-2">
                        <div className="d-flex align-items-center comp">
                          <i className="fas fa-lock-alt"></i>
                          <p>Complete the content above before moving on.</p>
                        </div>
                      </div>
                    )}
                  </div>
                  {activeStepsecond && (
                    <div className="col-lg-10 offset-md-1 py-5 mt-2">
                      <div className="d-flex flex-column gap-2 padding">
                        <h2>Cost Of Safety</h2>
                        <p ref={stepSecond}>
                          Explore the below slider to review how your approach
                          to health and safety can effect your organisation.
                        </p>
                      </div>
                      <div className="d-flex w-100 px-3">
                        <div
                          className="graph-count d-flex flex-column justify-content-around"
                          style={{ height: "48vh", width: "25px" }}
                        >
                          <p>High</p>
                          <p></p>
                          <p></p>
                          <p></p>
                          <p></p>
                          <p>Low</p>
                        </div>
                        <div className="d-flex flex-column w-100">
                          <div
                            className="graph-safty m-4 d-flex justify-content-around align-items-end"
                            style={{
                              height: "40vh",
                              width: "100%",
                              borderBottom: "1px solid black",
                              borderLeft: "1px solid black",
                            }}
                          >
                            <div
                              className="graph-line"
                              style={{
                                height: "15vh",
                                width: "5vw",
                                backgroundColor: "red",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "15vh",
                                width: "5vw",
                                backgroundColor: "green",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "15vh",
                                width: "5vw",
                                backgroundColor: "yellow",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "15vh",
                                width: "5vw",
                                backgroundColor: "red",
                              }}
                            ></div>
                          </div>
                          <div className="graph-count1 mx-4 w-100 d-flex justify-content-around text-center">
                            <p style={{ width: "5vw", textAlign: "center" }}>
                              Financial Cost
                            </p>
                            <p style={{ width: "5vw", textAlign: "center" }}>
                              Performance
                            </p>
                            <p style={{ width: "5vw", textAlign: "center" }}>
                              Staff Moral
                            </p>
                            <p style={{ width: "5vw", textAlign: "center" }}>
                              Legal Costs
                            </p>
                          </div>
                        </div>
                      </div>
                      {stepbutton2 && (
                        <div className="d-block padding btn-block text-center mt-4">
                          <button
                            type="button"
                            onClick={() => stepformlesson("Step2")}
                          >
                            CONTINUE
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                  {activeStepthird && (
                    <div
                      id="good"
                      className="col-lg-10 offset-md-1 py-3 padding"
                    >
                      <div className="d-flex flex-column gap-3">
                        <h2>Good Health and safety</h2>
                        <p ref={stepThird}>
                          When a business takes steps to keep everyone safe and
                          healthy, it boosts morale and makes the workplace
                          better. This means happier employees and better
                          results for the company.
                        </p>
                      </div>
                    </div>
                  )}
                  {activeStepthird && (
                    <div
                      id="Poor"
                      className="col-lg-10 offset-md-1 py-3 padding"
                    >
                      <div className="d-flex flex-column gap-3">
                        <h2>Poor health And Safety</h2>
                        <p>
                          On the flip side, if a company has bad health and
                          safety practices, it can harm the organization in
                          several ways. This might mean more expenses because of
                          accidents, more claims for worker compensation, higher
                          insurance costs, unhappy employees, and, in the end, a
                          damaged business reputation. These problems can
                          seriously hurt the organization and might even make it
                          go out of business.
                        </p>
                      </div>
                    </div>
                  )}
                  {stepbutton3 && (
                    <div className="d-block padding btn-block text-center mt-4">
                      <button
                        type="button"
                        onClick={() => stepformlesson("Step3")}
                      >
                        CONTINUE
                      </button>
                    </div>
                  )}
                  {activeStepforth && (
                    <div
                      id="Injury"
                      className="col-lg-10 offset-md-1 py-3 padding"
                    >
                      <div className="d-flex flex-column gap-2">
                        <h2>Injury / illness Statistics</h2>
                        <p ref={stepForth}>
                          In 2020, Australia recorded 194 work-related deaths,
                          equivalent to 1.5 fatalities per 100,000 workers.
                          Additionally, there were 130,195 claims for serious
                          injuries or illnesses during the 2019-2020 financial
                          year.
                        </p>
                        <h5 className="py-4">
                          Australian Serious Claims By Mechanism of Incident
                          (%),
                          <br />
                          2019 - 2020
                        </h5>
                      </div>
                      <div className="d-flex w-100 p-3">
                        <div
                          className="graph-count d-flex flex-column justify-content-around"
                          style={{ height: "68vh", width: "25px" }}
                        >
                          <p>40</p>
                          <p>30</p>
                          <p>20</p>
                          <p>10</p>
                          <p>00</p>
                        </div>
                        <div className="d-flex flex-column w-100">
                          <div
                            className="graph-safty m-4 d-flex justify-content-around align-items-end"
                            style={{
                              height: "60vh",
                              width: "100%",
                              borderBottom: "1px solid black",
                              borderLeft: "1px solid black",
                            }}
                          >
                            <div
                              className="graph-line"
                              style={{
                                height: "40vh",
                                width: "1vw",
                                backgroundColor: "red",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "30vh",
                                width: "1vw",
                                backgroundColor: "green",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "25vh",
                                width: "1vw",
                                backgroundColor: "yellow",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "20vh",
                                width: "1vw",
                                backgroundColor: "red",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "40vh",
                                width: "1vw",
                                backgroundColor: "yellow",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "35vh",
                                width: "1vw",
                                backgroundColor: "red",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "38vh",
                                width: "1vw",
                                backgroundColor: "green",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "28vh",
                                width: "1vw",
                                backgroundColor: "yellow",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "39vh",
                                width: "1vw",
                                backgroundColor: "red",
                              }}
                            ></div>
                          </div>
                          <div className="graph-count1 mx-4 w-100 d-flex justify-content-around text-center">
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Body Stressing
                            </p>
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Falls trips
                            </p>
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Hit by moving
                            </p>
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Mental stress
                            </p>
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Hitting objects
                            </p>
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Other
                            </p>
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Vehicle
                            </p>
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Environmental
                            </p>
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Chemicals
                            </p>
                          </div>
                        </div>
                      </div>
                      <span>
                        (<strong>Source:</strong> SafeWork Australia)
                      </span>
                      <h5 className="py-4">
                        Percentage of Fatal Injuries in Australia by
                        Work-Related Mechanism, <br />
                        2020
                      </h5>

                      <div className="d-flex w-100 p-3">
                        <div
                          className="graph-count d-flex flex-column justify-content-around"
                          style={{ height: "68vh", width: "25px" }}
                        >
                          <p>50</p>
                          <p>40</p>
                          <p>30</p>
                          <p>20</p>
                          <p>10</p>
                          <p>00</p>
                        </div>
                        <div className="d-flex flex-column w-100">
                          <div
                            className="graph-safty m-4 d-flex justify-content-around align-items-end"
                            style={{
                              height: "60vh",
                              width: "100%",
                              borderBottom: "1px solid black",
                              borderLeft: "1px solid black",
                            }}
                          >
                            <div
                              className="graph-line"
                              style={{
                                height: "40vh",
                                width: "1vw",
                                backgroundColor: "red",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "30vh",
                                width: "1vw",
                                backgroundColor: "green",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "25vh",
                                width: "1vw",
                                backgroundColor: "yellow",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "20vh",
                                width: "1vw",
                                backgroundColor: "red",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "40vh",
                                width: "1vw",
                                backgroundColor: "yellow",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "35vh",
                                width: "1vw",
                                backgroundColor: "red",
                              }}
                            ></div>
                            <div
                              className="graph-line"
                              style={{
                                height: "38vh",
                                width: "1vw",
                                backgroundColor: "green",
                              }}
                            ></div>
                          </div>
                          <div className="graph-count1 mx-4 w-100 d-flex justify-content-around text-center">
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Vehicle
                            </p>
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Hit by moving
                            </p>
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Falls from a
                            </p>
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Hit by falling
                            </p>
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Trapped Between
                            </p>
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Trapped by
                            </p>
                            <p
                              style={{
                                width: "1vw",
                                textAlign: "center",
                                transform: "rotate(315deg)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "start",
                              }}
                            >
                              Other
                            </p>
                          </div>
                        </div>
                      </div>
                      <span>
                        (<strong>Source:</strong> SafeWork Australia)
                      </span>
                      <div id="conti-btn" className="d-flex py-2">
                        <button
                          type="button"
                          onClick={() => stepformlesson("Step4")}
                        >
                          CONTINUE
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          )}
          {lesson2 && (
            <section id="legig" className="legi w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={second}
                  to="#introd"
                  onClick={() => lessonInstruction("1")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 1 Introduction</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 2 of 9</h4>
                      <h1>Laws</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1 padding">
                    <div className="d-flex flex-column gap-5 py-3 py-md-5">
                      <p>
                        In this section, we'll explain the organization and
                        enforcement of health and safety regulations.
                      </p>
                      <h2>Overview</h2>
                      <div className="d-flex justify-content-center text-center">
                        <div
                          className="pyramid"
                          style={{
                            clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)",
                            width: "320px",
                          }}
                        >
                          <div
                            className="pyramid-box1 d-flex justify-content-center align-items-center"
                            style={{
                              backgroundColor: "black",
                              color: "white",
                              height: "80px",
                              fontSize: "18px",
                              fontWeight: "500",
                            }}
                          >
                            <p>Act</p>
                          </div>
                          <div
                            className="pyramid-box2 d-flex justify-content-center align-items-center"
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              height: "80px",
                              fontSize: "18px",
                              fontWeight: "500",
                            }}
                          >
                            <p>Regulation</p>
                          </div>
                          <div
                            className="pyramid-box3 d-flex justify-content-center align-items-center"
                            style={{
                              backgroundColor: "green",
                              color: "white",
                              height: "80px",
                              fontSize: "18px",
                              fontWeight: "500",
                            }}
                          >
                            <p>
                              Approved Codes of <br />
                              Practice
                            </p>
                          </div>
                          <div
                            className="pyramid-box4 d-flex justify-content-center align-items-center"
                            style={{
                              backgroundColor: "blue",
                              color: "white",
                              height: "80px",
                              fontSize: "18px",
                              fontWeight: "500",
                            }}
                          >
                            <p>
                              Guidance Materials and
                              <br />
                              ANZ Standards
                            </p>
                          </div>
                        </div>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                          <p
                            id="set"
                            style={{
                              height: "80px",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "18px",
                              fontWeight: "500",
                              color: "black",
                            }}
                          >
                            Set out the duties Obligations of the parties
                          </p>
                          <p
                            id="met"
                            style={{
                              height: "80px",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "18px",
                              fontWeight: "500",
                              color: "black",
                            }}
                          >
                            How some of these duties must be met
                          </p>
                          <p
                            id="pract"
                            style={{
                              height: "80px",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "18px",
                              fontWeight: "500",
                              color: "black",
                            }}
                          >
                            Practical guidance on how you should meet these
                            duties.
                          </p>
                          <p
                            id="guide"
                            style={{
                              height: "80px",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "18px",
                              fontWeight: "500",
                              color: "black",
                            }}
                          >
                            Guidelines, factsheet and other informations
                          </p>
                        </div>
                      </div>
                      {step1active && (
                        <div className="d-block w-100 btn-block text-center">
                          <button
                            type="button"
                            onClick={() => stepformlesson2("Step1")}
                          >
                            CONTINUE
                          </button>
                        </div>
                      )}
                    </div>
                    {step2active && (
                      <div className="d-flex flex-column align-items-center py-3 py-md-5 health-safety">
                        <div className="health d-flex flex-column gap-4">
                          <div className="d-flex flex-column gap-2">
                            <h3>Safety and Health Laws</h3>
                            <p>
                              In all Australian regions, the relevant health and
                              safety acts establish the foundation for health
                              and safety standards. These acts impose a general
                              duty on all parties involved, qualified by what is
                              deemed "reasonably practicable" or achievable for
                              maintaining a healthy and safe workplace.
                            </p>
                          </div>
                          <div className="d-flex flex-column gap-2">
                            <p>
                              The specific acts across Australia are as follows:
                            </p>
                            <ul className="d-flex flex-column gap-3">
                              <li>
                                <p>
                                  <strong>New South Wales:</strong> Work Health
                                  and Safety Act 2011.
                                </p>
                              </li>
                              <li>
                                <p>
                                  <strong>Queensland:</strong> Work Health and
                                  Safety Act 2011.
                                </p>
                              </li>
                              <li>
                                <p>
                                  <strong>South Australia:</strong> Work Health
                                  and Safety Act 2012.
                                </p>
                              </li>
                              <li>
                                <p>
                                  <strong>Tasmania:</strong> Work Health and
                                  Safety Act 2012 and Work Health and Safety
                                  (Transitional and Consequences Provisions) Act
                                  2012.
                                </p>
                              </li>
                              <li>
                                <p>
                                  <strong>Northern Territory: </strong> Work
                                  Health and Safety (National Uniform
                                  Legislation) Act 2011.
                                </p>
                              </li>
                              <li>
                                <p>
                                  <strong>
                                    Australian Capital Territory:{" "}
                                  </strong>{" "}
                                  Work Health and Safety Act 2011.
                                </p>
                              </li>
                              <li>
                                <p>
                                  <strong>Victoria:</strong> Occupational Health
                                  and Safety Act 2004.
                                </p>
                              </li>
                              <li>
                                <p>
                                  <strong>Western Australia :</strong> Work
                                  Health and Safety Act 2020.
                                </p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="s-line"></div>
                        <div className="health d-flex flex-column gap-4">
                          <div className="d-flex flex-column gap-2">
                            <h3>Safety and Health Rules</h3>
                            <p>
                              In every jurisdiction, there are numerous rules
                              associated with the acts. These regulations
                              outline how certain duties specified in the acts
                              must be fulfilled and establish procedural or
                              administrative requirements to support them. For
                              instance, they may mandate licenses for particular
                              activities and the maintenance of records. There
                              are also various industry-specific regulations,
                              such as those concerning electrical installations,
                              construction work, and the handling of hazardous
                              chemicals.
                            </p>
                          </div>
                          <div className="d-flex flex-column gap-2">
                            <p>
                              Furthermore, apart from regulations aimed at
                              safeguarding the health and safety of workers, the
                              legislation also mandates workplaces to provide
                              appropriate welfare amenities, including:
                            </p>
                            <ul
                              id="ul-number"
                              className="d-flex flex-column gap-3"
                            >
                              <li>
                                <p>
                                  <strong>
                                    Toilets, with suitable changing facilities
                                    if necessary.
                                  </strong>
                                </p>
                              </li>
                              <li>
                                <p>
                                  <strong>
                                    Adequate washing facilities, including{" "}
                                  </strong>
                                  - access to hot water and soap.
                                </p>
                              </li>
                              <li>
                                <p>
                                  <strong>Provision of drinking water.</strong>
                                </p>
                              </li>

                              <li>
                                <p>
                                  <strong>Rest areas, </strong> - swith seats
                                  provided for breaks.
                                </p>
                              </li>
                              <li>
                                <p>
                                  <strong>
                                    Facilities for meal preparation and
                                    consumption.
                                  </strong>
                                </p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="s-line"></div>
                        <div className="health d-flex flex-column gap-4">
                          <div
                            className="d-flex flex-column gap-2"
                            ref={stepTwo}
                          >
                            <h3>Guidelines for Practice</h3>
                            <p>
                              SafeWork Australia creates Codes of Practice to
                              assist state and territory regulators. These codes
                              offer detailed guidance on how to implement and
                              apply regulations effectively.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    {step2activeBtn && (
                      <div className="d-block padding btn-block text-center">
                        <button
                          type="button"
                          onClick={() => stepformlesson2("Step2")}
                        >
                          CONTINUE
                        </button>
                      </div>
                    )}
                  </div>
                  {step3active && (
                    <div className="col-lg-10 offset-md-1 padding py-5 Enfo">
                      <div className="d-flex flex-column gap-2 py-5">
                        <h2>Enforcement Authorities in Australia</h2>
                      </div>
                    </div>
                  )}
                  {step3active && (
                    <div className="staff-img py-4">
                      <img
                        className="w-100"
                        src={require("../assets/ohs/images/se4.png")}
                        alt="img"
                      />
                    </div>
                  )}
                  {step3active && (
                    <div className="col-lg-10 offset-md-1 padding py-5 enfo">
                      <p>
                        The regulators are the governing bodies responsible for
                        enforcing and overseeing workplace health, safety, and
                        welfare within their respective jurisdiction.
                      </p>
                      <div className="d-flex align-items-center justify-content-center">
                        <div className="safe-img py-4">
                          <img
                            className="w-100"
                            src={require("../assets/ohs/images/se5.jpg")}
                            alt="img"
                          />
                        </div>
                      </div>
                      <p>
                        Some agencies also conduct formal research into
                        work-related risks, and SafeWork Australia compiles
                        national statistical data on health and safety at work.
                        However, it's important to note that SafeWork Australia
                        is not a regulatory body and lacks enforcement powers.
                      </p>

                      <p ref={stepTwo_2}>
                        Apart from health and safety legislation, various legal
                        requirements affect worker health and safety, including
                        fire safety, environmental regulations, and building
                        codes. Typically, these are overseen by local
                        authorities such as councils or other state or territory
                        agencies.
                      </p>
                    </div>
                  )}
                </div>
                {step3active && (
                  <div className="d-block padding btn-block text-center mb-4">
                    <button
                      type="button"
                      onClick={() => stepformlesson2("Step3")}
                    >
                      CONTINUE
                    </button>
                  </div>
                )}
              </div>
              {step4active && (
                <div id="good" className="col-lg-10 offset-md-1 py-5 padding">
                  <div className="d-flex flex-column gap-3">
                    <h2>Powers Of Enforcement Authorities</h2>
                    <p ref={stepTwo_3}>
                      To ensure compliance with health and safety laws,
                      enforcement authorities possess substantial powers. These
                      powers are delegated to health and safety inspectors,
                      granting them the authority to enter, search, and inspect
                      workplaces in response to complaints and workplace
                      incidents.
                    </p>
                  </div>
                </div>
              )}
              {step4active && (
                <div className="d-block padding btn-block text-center mb-4">
                  <button
                    type="button"
                    onClick={() => stepformlesson2("Step4")}
                  >
                    CONTINUE
                  </button>
                </div>
              )}
            </section>
          )}
          {lesson3 && (
            <section id="hum" className="human w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={third}
                  to="#legig"
                  onClick={() => lessonInstruction("2")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 2 Laws</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 3 of 9</h4>
                      <h1>Human Aspects</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1 padding">
                    <div className="d-flex flex-column gap-5 py-3 py-md-5">
                      <p>
                        The next section will examine the elements that
                        influence health and safety in the workplace:
                      </p>
                      <div className="d-flex flex-column gap-3">
                        <div className="d-flex align-items-center gap-5">
                          <div className="no">
                            <p>1</p>
                          </div>
                          <p>Personal factors.</p>
                        </div>
                        <div className="d-flex align-items-center gap-5">
                          <div className="no">
                            <p>2</p>
                          </div>
                          <p>Job-related factors.</p>
                        </div>
                        <div className="d-flex align-items-center gap-5">
                          <div className="no">
                            <p>3</p>
                          </div>
                          <p>Organizational factors.</p>
                        </div>
                      </div>
                    </div>
                    {step3btn_1 && (
                      <div
                        id="conti-btn"
                        onClick={() => stepformlesson3("Step1")}
                        className="d-flex py-4"
                      >
                        <button>CONTINUE</button>
                      </div>
                    )}
                  </div>

                  {step3section2 && (
                    <div className="col-lg-10 offset-md-1 padding py-5 Enfo">
                      <div className="d-flex flex-column gap-2">
                        <h2>What Is The Difference?</h2>
                      </div>
                    </div>
                  )}
                  {step3section2 && (
                    <div id="humn" className="d-flex align-items-center px-5">
                      <div className="row">
                        <div className="col-lg-6 py-4">
                          <img
                            className="object-fit-cover w-100 h-100"
                            src={require("../assets/ohs/images/se7.jpg")}
                            alt="img"
                          />
                        </div>
                        <div className="col-lg-6 py-4">
                          <img
                            className="object-fit-cover w-100 h-100"
                            src={require("../assets/ohs/images/se8.jpg")}
                            alt="img"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {step3section2 && (
                    <div
                      id="humn"
                      className="col-lg-10 offset-md-1 padding py-5 enfo"
                    >
                      <div className="d-flex flex-column gap-3">
                        <h2>People Don't Always Follow Rules</h2>
                        <p>
                          Merely having rules, expectations, attitudes, or
                          beliefs doesn't ensure making the "safe choice."
                        </p>
                        <p>
                          For instance, numerous drivers might acknowledge
                          driving above the speed limit, but their behavior
                          shifts when they realize there are consequences for
                          their actions.
                        </p>
                      </div>
                      {step3btn_2 && (
                        <div
                          id="conti-btn"
                          onClick={() => stepformlesson3("Step2")}
                          className="d-flex py-4"
                        >
                          <button>CONTINUE</button>
                        </div>
                      )}
                    </div>
                  )}

                  <div className="col-lg-10 offset-md-1 padding py-5 Enfo">
                    {step3section3 && (
                      <div className="d-flex justify-content-center align-items-center bg-light">
                        <div
                          className="card card-1 p-0 shadow"
                          style={{ maxWidth: "100%" }}
                        >
                          <nav>
                            <div
                              className="nav nav-tabs mb-3 nav-fill"
                              id="nav-tab"
                              role="tablist"
                            >
                              <button
                                className={`nav-link ${newtab === "1" ? "active" : ""
                                  } `}
                                id="nav-home-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-home"
                                type="button"
                                role="tab"
                                aria-controls="nav-home"
                                aria-selected="true"
                                onClick={() => tabSection("1")}
                              >
                                INDIVIDUAL
                              </button>
                              <button
                                className={`nav-link  ${newtab === "2" ? "active" : ""
                                  } `}
                                id="nav-profile-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-profile"
                                type="button"
                                role="tab"
                                aria-controls="nav-profile"
                                aria-selected="false"
                                onClick={() => tabSection("2")}
                              >
                                JOB
                              </button>
                              <button
                                className={`nav-link  ${newtab === "3" ? "active" : ""
                                  } `}
                                id="nav-contact-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-contact"
                                type="button"
                                role="tab"
                                aria-controls="nav-contact"
                                aria-selected="false"
                                onClick={() => tabSection("3")}
                              >
                                ORGANISATIONAL
                              </button>
                            </div>
                          </nav>
                          <div
                            className="tab-content p-4 bg-light"
                            id="nav-tabContent"
                          >
                            <div
                              className={`tab-pane fade ${newtab === "1" ? "active show" : ""
                                } `}
                              id="nav-home"
                              role="tabpanel"
                              aria-labelledby="nav-home-tab"
                            >
                              <p>
                                An individual's personality, skills, attitude,
                                and perception of risk all influence how they
                                approach a task.
                              </p>
                              <p>
                                Young workers (employees in Victoria), due to
                                their level of maturity and experience, are at
                                higher risk, necessitating additional
                                precautions compared to those for experienced
                                and older workers.
                              </p>
                              <div
                                className="acc-img py-3"
                                style={{ marginLeft: "88px" }}
                              >
                                <img
                                  className="w-100"
                                  src={require("../assets/ohs/images/young.jpg")}
                                  alt="img"
                                />
                              </div>
                            </div>
                            <div
                              className={`tab-pane fade ${newtab === "2" ? "active show" : ""
                                } `}
                              id="nav-profile"
                              role="tabpanel"
                              aria-labelledby="nav-profile-tab"
                            >
                              <p>
                                The safety is also significantly influenced by
                                the nature of the task and the environment in
                                which it takes place. This encompasses factors
                                such as the time needed to complete the task,
                                the workload of the worker (an employee in
                                Victoria), and the utilization of machinery or
                                controls.
                              </p>
                              <div
                                className="acc-img py-3"
                                style={{ marginLeft: "88px" }}
                              >
                                <img
                                  className="w-100"
                                  src={require("../assets/ohs/images/job.jpg")}
                                  alt="img"
                                />
                              </div>
                            </div>
                            <div
                              className={`tab-pane fade ${newtab === "3" ? "active show" : ""
                                } `}
                              id="nav-contact"
                              role="tabpanel"
                              aria-labelledby="nav-contact-tab"
                            >
                              <p>
                                The safety culture within an organization is one
                                of the most influential factors affecting
                                workplace health and safety. Effective
                                leadership, clear communication, and a shared
                                commitment to safety from management to
                                employees greatly influence how the workforce
                                will act and perform.
                              </p>
                              <div
                                className="acc-img py-3"
                                style={{ marginLeft: "88px" }}
                              >
                                <img
                                  className="w-100"
                                  src={require("../assets/ohs/images/org.jpg")}
                                  alt="img"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {step3btn_3 && (
                      <div
                        id="conti-btn"
                        onClick={() => stepformlesson3("Step3")}
                        className="d-flex py-4"
                      >
                        <button>CONTINUE</button>
                      </div>
                    )}
                    {step3section4 && (
                      <div id="carouselExample" className="carousel slide py-5">
                        <div className="carousel-inner">
                          <Slider {...settings_cro}>
                            <div className="carousel-item active">
                              <div className="silder-box1 d-flex flex-column gap-2 justify-content-center align-items-center text-center gap-1">
                                <h5>Environmental Conditions</h5>
                                <p>
                                  The surroundings where work takes place
                                  significantly impact safety.
                                </p>
                                <p>
                                  Explore the following sections to delve
                                  deeperimage
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <h1 className="py-2">Brightness Levels</h1>
                                <div className="d-flex justify-content-center">
                                  <div className="caro-img">
                                    <img
                                      src={require("../assets/ohs/images/low-brightness.jpg")}
                                      className="d-block w-100"
                                      alt="image"
                                    />
                                  </div>
                                </div>
                                <p className="py-2">
                                  Lighting conditions can have a significant
                                  impact on tasks being carried out. This could
                                  involve working in dimly lit areas or during
                                  nighttime, operating in excessively bright or
                                  glaring light, driving towards the sun on a
                                  road, or continuously viewing reflections on a
                                  control panel for extended periods.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <h1 className="py-2">Temperature Conditions</h1>
                                <div className="d-flex justify-content-center">
                                  <div className="caro-img">
                                    <img
                                      src={require("../assets/ohs/images/temp.jpg")}
                                      className="d-block w-100"
                                      alt="image"
                                    />
                                  </div>
                                </div>
                                <p className="py-2">
                                  Workplace temperatures can significantly
                                  influence the health and safety of workers and
                                  affect work performance.
                                </p>
                                <p className="pb-2">
                                  High temperatures, whether indoors or
                                  outdoors, can lead to heat stress and
                                  dehydration. On the other hand, prolonged
                                  exposure to low temperatures can cause
                                  hypothermia.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <h1 className="py-2">Noisy Conditions</h1>
                                <div className="d-flex justify-content-center">
                                  <div className="caro-img">
                                    <img
                                      src={require("../assets/ohs/images/noise.jpg")}
                                      className="d-block w-100"
                                      alt="image"
                                    />
                                  </div>
                                </div>
                                <p className="py-2">
                                  Loud environments can be distracting,
                                  diverting attention from nearby hazards. They
                                  may hinder communication, making it difficult
                                  to exchange important information and
                                  interfering with emergency warnings.
                                </p>
                                <h1 className="py-2">Recap</h1>
                                <p>
                                  Making sure you recognize and have pinpointed
                                  the environmental factors that could impact
                                  your ability to perform a task correctly is
                                  crucial for ensuring safety.
                                </p>
                                <p className="py-2">
                                  It's easy to overlook this aspect when
                                  completing a task, but it's essential to
                                  identify all hazards, assess them as needed,
                                  and implement appropriate control measures to
                                  minimize risks.
                                </p>
                              </div>
                            </div>
                          </Slider>
                        </div>

                        <div id="conti-btn" className="d-flex py-4">
                          <button
                            type="button"
                            onClick={() => stepformlesson3("Step4")}
                          >
                            CONTINUE
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson4 && (
            <section id="safety" className="Safety w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={forth}
                  to="#hum"
                  onClick={() => lessonInstruction("3")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 3 Human Aspects</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 4 of 9</h4>
                      <h1>Safety Signs</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1 padding">
                    <div className="d-flex flex-column gap-4 py-3 py-md-3">
                      <p>
                        Health and safety regulations mandate the use of safety
                        signs by PCBUs in specific situations. Consequently,
                        safety signs can complement other control measures
                        effectively.
                      </p>
                      <p>
                        When utilizing signs, regulations dictate adherence to a
                        standardized convention regarding shape and color. This
                        standardization aims to enhance comprehensibility and
                        align with international norms.
                      </p>
                    </div>

                    <h2>
                      Please browse the following tabs to familiarize yourself
                      with the common types of signage currently employed:
                    </h2>
                    <div className="py-3 d-flex justify-content-center align-items-center bg-light">
                      <div
                        className="card card-1 p-0 shadow"
                        style={{ maxWidth: "100%" }}
                      >
                        <nav>
                          <div
                            className="nav nav-tabs mb-3 nav-fill"
                            id="nav-tab1"
                            role="tablist"
                          >
                            <button
                              className={`nav-link ${tabsectionView === "Tab1" ? "active show" : ""
                                } `}
                              id="nav-home-tab1"
                              data-bs-toggle="tab"
                              data-bs-target="#nav-home1"
                              type="button"
                              role="tab"
                              aria-controls="nav-home"
                              aria-selected="true"
                              onClick={() => tabReview("Tab1")}
                            >
                              BLUE <br />( MANDATORY )
                            </button>
                            <button
                              className={`nav-link ${tabsectionView === "Tab2" ? "active show" : ""
                                } `}
                              id="nav-profile-tab2"
                              data-bs-toggle="tab"
                              data-bs-target="#nav-profile2"
                              type="button"
                              role="tab"
                              aria-controls="nav-profile"
                              aria-selected="false"
                              onClick={() => tabReview("Tab2")}
                            >
                              RED <br />
                              (PROHIBITIVE)
                            </button>
                            <button
                              className={`nav-link ${tabsectionView === "Tab3" ? "active show" : ""
                                } `}
                              id="nav-contact-tab3"
                              data-bs-toggle="tab"
                              data-bs-target="#nav-contact3"
                              type="button"
                              role="tab"
                              aria-controls="nav-contact"
                              aria-selected="false"
                              onClick={() => tabReview("Tab3")}
                            >
                              YELLOW <br />
                              (HAZARD)
                            </button>
                            <button
                              className={`nav-link ${tabsectionView === "Tab4" ? "active show" : ""
                                } `}
                              id="nav-green-tab4"
                              data-bs-toggle="tab"
                              data-bs-target="#nav-green4"
                              type="button"
                              role="tab"
                              aria-controls="nav-green4"
                              aria-selected="false"
                              onClick={() => tabReview("Tab4")}
                            >
                              GREEN <br />
                              (SAFE CONDITION)
                            </button>
                            <button
                              className={`nav-link ${tabsectionView === "Tab5" ? "active show" : ""
                                } `}
                              id="nav-red-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#nav-red"
                              type="button"
                              role="tab"
                              aria-controls="nav-red"
                              aria-selected="false"
                              onClick={() => tabReview("Tab5")}
                            >
                              Red <br />
                              (FIRE)
                            </button>
                          </div>
                        </nav>
                        <div
                          className="tab-content p-4 bg-light"
                          id="nav-tabContent"
                        >
                          <div
                            className={`tab-pane fade ${tabsectionView === "Tab1" ? "active show" : ""
                              } `}
                            id="nav-home1"
                            role="tabpanel"
                            aria-labelledby="nav-home-tab1"
                          >
                            <p>
                              Mandatory signs feature this color to signify a
                              compulsory action or instruction, such as wearing
                              a hard hat or ear protection in designated areas.
                              They are typically circular in shape.
                            </p>
                            <div className="acc-img1 py-3">
                              <img
                                className="w-100"
                                src={require("../assets/ohs/images/ACC2.png")}
                                alt="img"
                              />
                            </div>
                          </div>
                          <div
                            className={`tab-pane fade ${tabsectionView === "Tab2" ? "active show" : ""
                              } `}
                            id="nav-profile2"
                            role="tabpanel"
                            aria-labelledby="nav-profile-tab2"
                          >
                            <p>
                              The use of this color indicates a prohibition,
                              displaying actions that are not allowed, such as
                              stop signs and no smoking signs. These signs are
                              presented as a circle with a diagonal line.
                              Emergency stop devices are also colored red to
                              indicate the means of stopping a process or
                              equipment.
                            </p>
                            <div className="acc-img1 py-3">
                              <img
                                className="w-100"
                                src={require("../assets/ohs/images/red.png")}
                                alt="img"
                              />
                            </div>
                          </div>
                          <div
                            className={`tab-pane fade ${tabsectionView === "Tab3" ? "active show" : ""
                              } `}
                            id="nav-contact3"
                            role="tabpanel"
                            aria-labelledby="nav-contact-tab3"
                          >
                            <p>
                              This color serves as a warning, indicating
                              potential danger or risk. It is utilized to
                              highlight hazards like fire, explosion, chemicals,
                              or areas where caution should be exercised to
                              avoid potential danger, such as obstacles or
                              hazardous passages. Typically, these signs feature
                              an equilateral triangle with rounded corners,
                              although they may also be rectangular in shape.
                            </p>
                            <div className="acc-img1 py-3">
                              <img
                                className="w-100"
                                src={require("../assets/ohs/images/yellow.png")}
                                alt="img"
                              />
                            </div>
                          </div>
                          <div
                            className={`tab-pane fade ${tabsectionView === "Tab4" ? "active show" : ""
                              } `}
                            id="nav-green4"
                            role="tabpanel"
                            aria-labelledby="nav-green-tab4"
                          >
                            <p>
                              This color signifies a safe condition, indicating
                              features like emergency exits and the availability
                              of first aid. These signs are typically square or
                              rectangular in shape.
                            </p>
                            <div className="acc-img1 py-3">
                              <img
                                className="w-100"
                                src={require("../assets/ohs/images/green.png")}
                                alt="img"
                              />
                            </div>
                          </div>
                          <div
                            className={`tab-pane fade ${tabsectionView === "Tab5" ? "active show" : ""
                              } `}
                            id="nav-red"
                            role="tabpanel"
                            aria-labelledby="nav-red-tab"
                          >
                            <p>
                              Red is also employed to indicate fire-fighting
                              equipment, including extinguishers, and to denote
                              the location of such equipment. These signs are
                              presented in either a square or rectangle shape.
                            </p>
                            <div className="acc-img1 py-3">
                              <img
                                className="w-100"
                                src={require("../assets/ohs/images/red1.png")}
                                alt="img"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {btn4 && (
                      <div
                        id="conti-btn"
                        onClick={() => stepformlesson4("Step4")}
                        className="d-flex py-4"
                      >
                        <button>CONTINUE</button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson5 && (
            <section id="quiz" className="quiz w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={fifth}
                  to="#safety"
                  onClick={() => lessonInstruction("4")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 4 Safety Signs</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 5 of 9</h4>
                      <h1>Quiz at Mid-Point</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  {startQuizm && (
                    <div className="col-lg-10 offset-md-1 padding">
                      <div className="start py-5">
                        <Link
                          to="javascript:void(0)"
                          onClick={() => startQuiz()}
                        >
                          Start Quiz <i className="fas fa-chevron-right"></i>
                        </Link>
                      </div>
                    </div>
                  )}
                  {quizmain_Section && (
                    <div className="col-lg-10 offset-md-1 padding">
                      {section5_quiz1 && (
                        <div className="q1 py-5 d-flex flex-column gap-3">
                          <span>
                            Question
                            <br />
                            <strong>01/04</strong>
                          </span>
                          <p>
                            What colour are <strong>mandatory</strong> safety
                            signs?
                          </p>
                          <div className="d-flex py-5 flex-column gap-5">
                            <div class="d-flex gap-3">

                              <div class="position-relative d-flex justify-content-center align-items-center">
                                <input
                                  type="radio"
                                  id="yellow"
                                  name="safety_sign1"
                                  value="yellow"
                                  checked={checkQ_1 === "yellow"}
                                  onChange={() => startQuiz_1("yellow")}
                                />
                                {isfirstquiz &&
                                  (issetQuizAns_1_btn === "yellow" ? (
                                    <div className="check-1">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check-1">
                                      <i className="fas fa-times"></i>
                                    </div>
                                  ))}
                              </div>
                              <label for="yellow">Yellow</label>
                            </div>
                            <div class="d-flex gap-3">

                              <div class="position-relative d-flex justify-content-center align-items-center">
                                <input
                                  type="radio"
                                  id="red"
                                  name="safety_sign1"
                                  value="red"
                                  checked={checkQ_1 === "red"}
                                  onChange={() => startQuiz_1("red")}
                                />
                                {isfirstquiz &&
                                  (issetQuizAns_1_btn === "red" ? (
                                    <div className="check-1">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check-1">
                                      <i className="fas fa-times"></i>
                                    </div>
                                  ))}
                              </div>
                              <label for="red">Red</label>
                            </div>
                            <div className="d-flex gap-3">

                              <div class="position-relative d-flex justify-content-center align-items-center">
                                <input
                                  type="radio"
                                  id="blue"
                                  name="safety_sign1"
                                  value="blue"
                                  checked={checkQ_1 === "blue"}
                                  onChange={() => startQuiz_1("blue")}
                                />
                                {isfirstquiz &&
                                  (issetQuizAns_1_btn === "blue" ? (
                                    <div className="check-1">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check-1">
                                      <i className="fas fa-times"></i>
                                    </div>
                                  ))}
                              </div>
                              <label for="blue">Blue</label>
                            </div>
                            <div className="d-flex gap-3">

                              <div class="position-relative d-flex justify-content-center align-items-center">
                                <input
                                  type="radio"
                                  id="green"
                                  name="safety_sign1"
                                  value="green"
                                  checked={checkQ_1 === "green"}
                                  onChange={() => startQuiz_1("green")}
                                />
                                {isfirstquiz &&
                                  (issetQuizAns_1_btn === "green" ? (
                                    <div className="check-1">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check-1">
                                      <i className="fas fa-times"></i>
                                    </div>
                                  ))}
                              </div>
                              <label for="green">Green</label>
                            </div>
                          </div>
                          {worngansQuiz_1 && (
                            <div className="d-flex justify-content-center">
                              <div className="text-center">
                                <Link to="javascript:void(0)" className="">
                                  <i class="fas fa-times"></i>
                                </Link>
                                <p>
                                  <strong>Thanks for confirmation</strong>
                                </p>
                                <p>Sorry that's not correct.</p>
                              </div>
                            </div>
                          )}
                          {rightansQuiz_1 && (
                            <div className="d-flex justify-content-center">
                              <div className="text-center">
                                <Link to="javascript:void(0)" className="">
                                  <i class="fas fa-check"></i>
                                </Link>
                                <p>
                                  <strong>Thanks for confirmation</strong>
                                </p>
                                <p>That's correct - well done.</p>
                              </div>
                            </div>
                          )}
                          {firstsub && (
                            <div className="d-flex justify-content-center">
                              <button
                                type="button"
                                onClick={() => Quiz_check("1")}
                              >
                                Submit
                              </button>
                            </div>
                          )}
                          {firstnext && (
                            <div
                              className="d-flex justify-content-center"
                              ref={q1}
                            >
                              <button
                                type="button"
                                onClick={() => Quiz_next("1")}
                              >
                                Next
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                      {section5_quiz2 && (
                        <div className="q1 py-5 d-flex flex-column gap-3">
                          <span>
                            Question
                            <br />
                            <strong>02/04</strong>
                          </span>
                          <p>
                            The safety regulators can only talk to the manager
                            of a workplace?
                          </p>
                          <div className="d-flex py-5 flex-column gap-5">
                            <div className="d-flex gap-3">

                              <div class="position-relative d-flex justify-content-center align-items-center">
                                <input
                                  type="radio"
                                  id="Yes"
                                  name="second_2"
                                  value="Yes"
                                  checked={checkQ_2 === "Yes"}
                                  onChange={() => startQuiz_2("Yes")}
                                />
                                {issecondquiz &&
                                  (issetQuizAns_2_btn === "Yes" ? (
                                    <div className="check-1">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check-1">
                                      <i className="fas fa-times"></i>
                                    </div>
                                  ))}
                              </div>
                              <label for="Yes">True</label>
                            </div>
                            <div className="d-flex gap-3">

                              <div class="position-relative d-flex justify-content-center align-items-center">
                                <input
                                  type="radio"
                                  id="No"
                                  name="second_2"
                                  checked={checkQ_2 === "No"}
                                  value="No"
                                  onChange={() => startQuiz_2("No")}
                                />
                                {issecondquiz &&
                                  (issetQuizAns_2_btn === "No" ? (
                                    <div className="check-1">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check-1">
                                      <i className="fas fa-times"></i>
                                    </div>
                                  ))}
                              </div>
                              <label for="No">False</label>
                            </div>
                          </div>
                          {worngansQuiz_2 && (
                            <div className="d-flex justify-content-center">
                              <div className="text-center">
                                <Link to="javascript:void(0)" className="">
                                  <i class="fas fa-times"></i>
                                </Link>
                                <p>
                                  <strong>Thanks for confirmation</strong>
                                </p>
                                <p>Sorry that's not correct.</p>
                              </div>
                            </div>
                          )}
                          {rightansQuiz_2 && (
                            <div className="d-flex justify-content-center">
                              <div className="text-center">
                                <Link to="javascript:void(0)" className="">
                                  <i class="fas fa-check"></i>
                                </Link>
                                <p>
                                  <strong>Thanks for confirmation</strong>
                                </p>
                                <p>That's correct - well done.</p>
                              </div>
                            </div>
                          )}
                          {secondsub && (
                            <div className="d-flex justify-content-center">
                              <button
                                type="button"
                                onClick={() => Quiz_check("2")}
                              >
                                Submit
                              </button>
                            </div>
                          )}
                          {secondnext && (
                            <div
                              className="d-flex justify-content-center"
                              ref={q2}
                            >
                              <button
                                type="button"
                                onClick={() => Quiz_next("2")}
                              >
                                Next
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                      {section5_quiz3 && (
                        <div className="q1 py-5 d-flex flex-column gap-3">
                          <span>
                            Question
                            <br />
                            <strong>03/04</strong>
                          </span>
                          <p>
                            Safety signage is an effective means of controlling
                            risk in the workplace?
                          </p>
                          <div className="d-flex py-5 flex-column gap-5">
                            <div className="d-flex gap-3">

                              <div class="position-relative d-flex justify-content-center align-items-center">
                                <input
                                  type="radio"
                                  id="Yes"
                                  name="second_2"
                                  value="Yes"
                                  checked={checkQ_3 === "Yes"}
                                  onChange={() => startQuiz_3("Yes")}
                                />
                                {isthirdquiz &&
                                  (issetQuizAns_3_btn === "Yes" ? (
                                    <div className="check-1">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check-1">
                                      <i className="fas fa-times"></i>
                                    </div>
                                  ))}
                              </div>
                              <label for="Yes">True</label>
                            </div>
                            <div className="d-flex gap-3">

                              <div class="position-relative d-flex justify-content-center align-items-center">
                                <input
                                  type="radio"
                                  id="No"
                                  name="second_2"
                                  value="No"
                                  checked={checkQ_3 === "No"}
                                  onChange={() => startQuiz_3("No")}
                                />
                                {isthirdquiz &&
                                  (issetQuizAns_3_btn === "No" ? (
                                    <div className="check-1">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check-1">
                                      <i className="fas fa-times"></i>
                                    </div>
                                  ))}
                              </div>
                              <label for="No">False</label>
                            </div>
                          </div>
                          {worngansQuiz_3 && (
                            <div className="d-flex justify-content-center">
                              <div className="text-center">
                                <Link to="javascript:void(0)" className="">
                                  <i class="fas fa-times"></i>
                                </Link>
                                <p>
                                  <strong>Thanks for confirmation</strong>
                                </p>
                                <p>Sorry that's not correct.</p>
                              </div>
                            </div>
                          )}
                          {rightansQuiz_3 && (
                            <div className="d-flex justify-content-center">
                              <div className="text-center">
                                <Link to="javascript:void(0)" className="">
                                  <i class="fas fa-check"></i>
                                </Link>
                                <p>
                                  <strong>Thanks for confirmation</strong>
                                </p>
                                <p>That's correct - well done.</p>
                              </div>
                            </div>
                          )}
                          {thirdsub && (
                            <div className="d-flex justify-content-center">
                              <button
                                type="button"
                                onClick={() => Quiz_check("3")}
                              >
                                Submit
                              </button>
                            </div>
                          )}
                          {thirdnext && (
                            <div
                              className="d-flex justify-content-center"
                              ref={q3}
                            >
                              <button
                                type="button"
                                onClick={() => Quiz_next("3")}
                              >
                                Next
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                      {section5_quiz4 && (
                        <div className="q1 py-5 d-flex flex-column gap-3">
                          <span>
                            Question
                            <br />
                            <strong>04/04</strong>
                          </span>
                          <p>
                            Which of the following is <strong>not</strong>{" "}
                            considered part of the required workplace welfare
                            facilities?
                          </p>
                          <div className="d-flex py-5 flex-column gap-5">
                            <div className="d-flex gap-3">

                              <div class="position-relative d-flex justify-content-center align-items-center">
                                <input
                                  type="radio"
                                  id="toilets"
                                  name="forth_4"
                                  value="Toilets"
                                  checked={checkQ_4 === "Toilets"}
                                  onChange={() => startQuiz_4("Toilets")}
                                />
                                {isforthquiz &&
                                  (issetQuizAns_4_btn === "Toilets" ? (
                                    <div className="check-1">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check-1">
                                      <i className="fas fa-times"></i>
                                    </div>
                                  ))}
                              </div>
                              <label for="toilets">Toilets</label>
                            </div>
                            <div className="d-flex gap-3">

                              <div class="position-relative d-flex justify-content-center align-items-center">
                                <input
                                  type="radio"
                                  id="Appropriate_washing_facilities"
                                  name="forth_4"
                                  value="Appropriate_washing_facilities"
                                  checked={
                                    checkQ_4 ===
                                    "Appropriate_washing_facilities"
                                  }
                                  onChange={() =>
                                    startQuiz_4(
                                      "Appropriate_washing_facilities"
                                    )
                                  }
                                />
                                {isforthquiz &&
                                  (issetQuizAns_4_btn ===
                                    "Appropriate_washing_facilities" ? (
                                    <div className="check-1">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check-1">
                                      <i className="fas fa-times"></i>
                                    </div>
                                  ))}
                              </div>

                              <label for="Appropriate_washing_facilities">
                                Appropriate washing facilities
                              </label>
                            </div>
                            <div className="d-flex gap-3">

                              <div class="position-relative d-flex justify-content-center align-items-center">
                                <input
                                  type="radio"
                                  id="Availability_of_drinking_water"
                                  name="forth_4"
                                  value="Availability_of_drinking_water"
                                  checked={
                                    checkQ_4 ===
                                    "Availability_of_drinking_water"
                                  }
                                  onChange={() =>
                                    startQuiz_4(
                                      "Availability_of_drinking_water"
                                    )
                                  }
                                />
                                {isforthquiz &&
                                  (issetQuizAns_4_btn ===
                                    "Availability_of_drinking_water" ? (
                                    <div className="check-1">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check-1">
                                      <i className="fas fa-times"></i>
                                    </div>
                                  ))}
                              </div>

                              <label for="Availability_of_drinking_water">
                                Availability of drinking water
                              </label>
                            </div>
                            <div className="d-flex gap-3">

                              <div class="position-relative d-flex justify-content-center align-items-center">
                                <input
                                  type="radio"
                                  id="Provision_of_a_work_vehicle_to_purchase_lunch"
                                  name="forth_4"
                                  value="Provision_of_a_work_vehicle_to_purchase_lunch"
                                  checked={
                                    checkQ_4 ===
                                    "Provision_of_a_work_vehicle_to_purchase_lunch"
                                  }
                                  onChange={() =>
                                    startQuiz_4(
                                      "Provision_of_a_work_vehicle_to_purchase_lunch"
                                    )
                                  }
                                />
                                {isforthquiz &&
                                  (issetQuizAns_4_btn ===
                                    "Provision_of_a_work_vehicle_to_purchase_lunch" ? (
                                    <div className="check-1">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check-1">
                                      <i className="fas fa-times"></i>
                                    </div>
                                  ))}
                              </div>

                              <label for="Provision_of_a_work_vehicle_to_purchase_lunch">
                                Provision of a work vehicle to purchase lunch
                              </label>
                            </div>
                          </div>

                          {worngansQuiz_4 && (
                            <div className="d-flex justify-content-center">
                              <div className="text-center">
                                <Link to="javascript:void(0)" className="">
                                  <i class="fas fa-times"></i>
                                </Link>
                                <p>
                                  <strong>Thanks for confirmation</strong>
                                </p>
                                <p>Sorry that's not correct.</p>
                              </div>
                            </div>
                          )}
                          {rightansQuiz_4 && (
                            <div className="d-flex justify-content-center">
                              <div className="text-center">
                                <Link to="javascript:void(0)" className="">
                                  <i class="fas fa-check"></i>
                                </Link>
                                <p>
                                  <strong>Thanks for confirmation</strong>
                                </p>
                                <p>That's correct - well done.</p>
                              </div>
                            </div>
                          )}
                          {forthsub && (
                            <div className="d-flex justify-content-center">
                              <button
                                type="button"
                                onClick={() => Quiz_check("4")}
                              >
                                Submit
                              </button>
                            </div>
                          )}
                          {forthnext && (
                            <div
                              className="d-flex justify-content-center"
                              ref={q4}
                            >
                              <button
                                type="button"
                                onClick={() => Quiz_next("4")}
                              >
                                Next
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  {quiz5_result_section && (
                    <div className="d-flex justify-content-center  align-items-center py-4">
                      <div
                        className="pie position-relative "
                        data-pie='{ "cut": 30, "percent": 75, "rotation": 144, "colorSlice": "#F50057", "colorCircle": "#f1f1f1", "textPosition": "1em", "fontSize": "1.2rem" }'
                        data-pie-index="1"
                        style={{ width: "500px", height: "500px" }}
                      >
                        <svg
                          role="progressbar"
                          width="500"
                          height="500"
                          viewBox="0 0 100 100"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          aria-valuenow="56"
                        >
                          <circle
                            cx="50%"
                            cy="50%"
                            r="42"
                            shape-rendering="geometricPrecision"
                            fill="none"
                            stroke="#f1f1f1"
                            stroke-width="2"
                            stroke-dashoffset="79.19999999999999"
                            style={{
                              transform: "rotate(144deg)",
                              transformOrigin: "50% 50%",
                            }}
                            stroke-dasharray="264"
                            stroke-linecap=""
                          ></circle>
                          <circle
                            cx="50%"
                            cy="50%"
                            r="42"
                            shape-rendering="geometricPrecision"
                            className="pie-circle-1"
                            fill="none"
                            stroke-width="2"
                            stroke-dashoffset="160.512"
                            stroke-linecap=""
                            style={{
                              transform: "rotate(144deg)",
                              transformOrigin: "50% 50%",
                              strokeDasharray: finalperc,
                            }}
                            stroke={stroke_5}
                            data-angel="56"
                          ></circle>
                        </svg>
                        <div className="pie-text-1">
                          <p>Your score {isresult}</p>
                          <i className="fas fa-check"></i>
                        </div>
                        <div className="percentage">
                          <p>Passing</p>
                          <p>{isresult}</p>
                        </div>
                        <div className="refresh">
                          <i
                            className="fas fa-redo"
                            onClick={restart_lesson5}
                          ></i>
                        </div>
                      </div>
                    </div>
                  )}
                  {quiz5_result_section && (
                    <div className="d-flex flex-column">
                      <Link
                        to="#quiz"
                        onClick={() => lessonInstruction("6")}
                        className="backpage text-center d-flex flex-column"
                      >
                        <i className="far fa-angle-down"></i>
                        <h5>Lesson 6 Quiz at Mid-Points</h5>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </section>
          )}
          {lesson6 && (
            <section id="work" className="work w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={sixth}
                  to="#quiz"
                  onClick={() => lessonInstruction("5")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 5 Quiz at Mid-Points</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 6 of 9</h4>
                      <h1>Workplace Incidents</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1 padding">
                    {section6_1 && (
                      <div className="py-3">
                        <h3>Definitions</h3>
                        <p>
                          Take a look at the following cards to grasp the
                          meanings of these frequently used terms:
                        </p>
                      </div>
                    )}
                    {section6_1 && (
                      <div className="row">
                        <div className="col-lg-6 fp-1 position-relative">
                          <div className="flip-card p-3">
                            <div
                              className={
                                isFlipped6
                                  ? "flip-card-inner step6_"
                                  : "flip-card-inner"
                              }
                            >
                              <div className="flip-card-front">
                                <span>Incidents</span>
                              </div>
                              <div className="flip-card-back">
                                <p>
                                  An instance of an event or occurrence
                                  happening. Previously referred to as
                                  accidents, this term typically denotes an
                                  event where a worker sustains an injury or
                                  illness requiring more than general first aid,
                                  or has the potential to cause such harm.
                                </p>
                                <p>
                                  Some incidents are considered serious enough
                                  to warrant reporting to the health and safety
                                  regulator.
                                </p>
                              </div>
                            </div>
                          </div>
                          <button
                            id="h-btn"
                            type="button"
                            className="btn btn-secondary"
                            data-bs-toggle="tooltip"
                            data-bs-title="Click to flip"
                            onClick={() => step6_1("1")}
                          >
                            <i className="far fa-sync-alt"></i>
                          </button>
                        </div>
                        <div className="col-lg-6 fp-1 position-relative">
                          <div className="flip-card p-3">
                            <div
                              className={
                                isFlipped6_1
                                  ? "flip-card-inner step6_"
                                  : "flip-card-inner"
                              }
                            >
                              <div className="flip-card-front">
                                <span>
                                  Dangerous Incident
                                  <br />
                                  (also referred to as Dangerous Occurrence or
                                  Near Miss)
                                </span>
                              </div>
                              <div className="flip-card-back">
                                <p>
                                  A narrowly avoided event that could have led
                                  to serious injuries, harm, or damage. Certain
                                  specified near misses also need to be reported
                                  to the health and safety regulator.
                                </p>
                              </div>
                            </div>
                          </div>
                          <button
                            id="h-btn"
                            type="button"
                            className="btn btn-secondary"
                            data-bs-toggle="tooltip"
                            data-bs-title="Click to flip"
                            onClick={() => step6_1("2")}
                          >
                            <i className="far fa-sync-alt"></i>
                          </button>
                        </div>
                      </div>
                    )}
                    {step6_btn1 && (
                      <div
                        id="conti-btn"
                        onClick={() => step6_btn_1()}
                        className="d-flex py-3"
                      >
                        <button type="button" ref={scl_6_1}>
                          CONTINUE
                        </button>
                      </div>
                    )}
                    {section6_2 && (
                      <div
                        id=""
                        className="report d-flex flex-column gap-3 py-4"
                      >
                        <h4>What Incidents Need to be Reported?</h4>
                        <div className="d-flex flex-column gap-4">
                          <p>
                            In all jurisdictions, certain incidents and
                            illnesses must be reported to the health and safety
                            regulators.
                          </p>
                          <p>
                            If an incident occurs at your workplace that
                            necessitates notification to the regulator, it is
                            crucial to report it promptly.
                          </p>
                          <p>
                            Typical incidents requiring notification include:
                          </p>
                          <ul className="d-flex flex-column gap-3 rep-ul">
                            <li>
                              <strong>The death of a person at work.</strong>
                            </li>
                            <li>
                              <strong>
                                A serious injury or illness requiring immediate
                                hospitalization.
                              </strong>
                            </li>
                            <li>
                              <strong>
                                Loss of consciousness or loss of bodily
                                function.
                              </strong>
                            </li>
                            <li>
                              <strong>Electric shock.</strong>
                            </li>
                            <li>
                              <strong>
                                Exposure to hazardous chemicals requiring
                                medical treatment.
                              </strong>
                            </li>
                            <li>
                              <strong>
                                Dangerous incidents or near misses, such as
                                crane failure or equipment falls.
                              </strong>
                            </li>
                            <li>
                              <strong>
                                Uncontrolled release of hazardous chemicals.
                              </strong>
                            </li>
                            <li>
                              <strong> Uncontrolled fire or explosion.</strong>
                            </li>
                          </ul>
                          <p ref={scl_6_2}>
                            The Advice Line can offer guidance to clients unsure
                            if an incident warrants notification to the
                            regulator.
                          </p>
                        </div>
                      </div>
                    )}
                    {section6_2 && (
                      <div
                        id="conti-btn"
                        onClick={() => step6_btn_2()}
                        className="d-flex py-3"
                      >
                        <button>CONTINUE</button>
                      </div>
                    )}
                    {section6_3 && (
                      <div
                        id="report"
                        className="d-flex flex-column gap-3 py-4"
                      >
                        <h4>Reporting to the Regulator</h4>
                        <div className="d-flex flex-column gap-4">
                          <p>
                            If your workplace experiences an incident requiring
                            notification to the regulator, it's crucial for
                            everyone to cooperate fully with their requests.
                            This includes providing a written report about the
                            incident if asked, along with any necessary
                            information.
                          </p>
                          <p>
                            If the regulator decides to conduct an investigation
                            into the incident, it is legally required for all
                            individuals to cooperate with the process. This may
                            involve participating in formal interviews if
                            requested..
                          </p>
                          <p ref={scl_6_3}>
                            If the Regulator instructs or asks you to provide
                            information and documents, contact the Advice Line
                            for assistance.
                          </p>
                        </div>
                      </div>
                    )}
                    {section6_3 && (
                      <div
                        id="conti-btn"
                        onClick={() => step6_btn_3()}
                        className="d-flex py-3"
                      >
                        <button>CONTINUE</button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson7 && (
            <section id="Injury1" className="human w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={seven}
                  to="#work"
                  onClick={() => lessonInstruction("6_6")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 6 Workplace Incidents</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 7 of 9</h4>
                      <h1>How to Report an Injury</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1 padding py-5 Enfo">
                    <div id="carouselExample1" className="carousel slide py-5">
                      <div className="carousel-inner">
                        <Slider {...settings}>
                          <div className="carousel-item active">
                            <div className="silder-box1 d-flex flex-column gap-2 justify-content-center align-items-center text-center gap-1">
                              <h5>How to Report an Injury</h5>
                              <p>
                                When an injury occurs, it's important that
                                everyone in the organization knows what steps to
                                take. Here are the procedures to follow:
                              </p>
                            </div>
                          </div>
                          <div className="carousel-item">
                            <div className="silder-box2">
                              <h1 className="py-2">Obtain Medical Care</h1>

                              <p className="py-2">
                                When a workplace injury occurs, the primary and
                                immediate priority is to seek medical treatment
                                for the injury. Every workplace should be
                                equipped to offer an appropriate level of first
                                aid based on the nature, size, complexity of
                                hazards and risks, and location of the
                                workplace.
                              </p>
                              <p>
                                This might involve having trained first aid
                                officers available or ensuring that workers can
                                easily access trained first aid officers who can
                                promptly respond and provide immediate
                                assistance.
                              </p>
                              <p className="py-2">
                                <strong>Record Relevant Details</strong>
                              </p>
                              <div className="d-flex justify-content-center">
                                <div className="caro-img">
                                  <img
                                    src={require("../assets/ohs/images/medical.jpg")}
                                    className="d-block w-100"
                                    alt="..."
                                  />
                                </div>
                              </div>
                              <p className="py-2">
                                After administering proper care or treatment to
                                the injured individual, it's essential to record
                                all relevant details, including the time and
                                location of the injury, as well as any
                                contributing factors, in a first aid injury
                                register.
                              </p>
                            </div>
                          </div>
                          <div className="carousel-item">
                            <div className="silder-box2">
                              <h1 className="py-2">
                                Complete The Incident Reporting Form
                              </h1>

                              <p className="py-2">
                                If the injury necessitates more than minimal
                                first aid or has the potential to result in such
                                an injury, an incident report should be filled
                                out. Accuracy and thoroughness are crucial when
                                completing this form, and it should be submitted
                                within the organization promptly after the
                                incident occurs.
                              </p>
                            </div>
                          </div>
                          <div className="carousel-item">
                            <div className="silder-box2">
                              <h1 className="py-2">Incident Investigation</h1>

                              <p className="py-2">
                                After the incident, the PCBU (employer in
                                Victoria) is responsible for ensuring that
                                corrective actions are taken and procedures are
                                reviewed and updated if needed. Therefore,
                                conducting an incident investigation is the most
                                suitable course of action, as the PCBU must take
                                all "reasonably practicable" measures to prevent
                                the recurrence of a similar incident.
                              </p>
                            </div>
                          </div>
                        </Slider>
                      </div>
                    </div>
                    <div id="conti-btn" className="d-flex py-4">
                      {btn7 && (
                        <button type="button" onClick={() => step_btn_7()}>
                          CONTINUE
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson8 && (
            <section id="workplace" className="human w-100">
              <div className="d-flex flex-column">
                <Link
                  to="#Injury1"
                  onClick={() => lessonInstruction("7_7")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 7 - How To Report An Injury</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 8 of 9</h4>
                      <h1>Some Common Workplace Hazards</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  {sect_8_1 && (
                    <div className="col-lg-10 offset-md-1 padding py-5 Enfo">
                      <div
                        id=""
                        className="report d-flex flex-column gap-3 py-4"
                      >
                        <h4>Slips, Trips and Falls</h4>
                        <div className="d-flex flex-column gap-4">
                          <p>
                            Slips, trips, or falls on the same level make up a
                            significant portion of workplace injuries. The
                            primary causes of these incidents include:
                          </p>
                          <div className="row">
                            <div className="col-lg-6 order-md-1">
                              <div className="img-block fulw">
                                <img
                                  src={require("../assets/ohs/images/some1.jpg")}
                                  alt="image"
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 order-md-0">
                              <ul className="d-flex flex-column gap-3 rep-ul">
                                <li>
                                  Slippery or contaminated floor surfaces.
                                </li>
                                <li>Uneven or damaged flooring or stairs.</li>
                                <li>Inappropriate footwear.</li>
                                <li>Poor lighting.</li>
                                <li>Human behavior.</li>
                              </ul>
                            </div>
                            <div className="col-lg-6 order-md-2">
                              <div className="img-block fulw">
                                <img
                                  src={require("../assets/ohs/images/some2.jpg")}
                                  alt="image"
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 order-md-3">
                              <ul className="d-flex flex-column gap-3 rep-ul">
                                <li>
                                  Continuous facilities management (preventive
                                  maintenance).
                                </li>
                                <li>Proper housekeeping.</li>
                                <li>Reporting of hazards.</li>
                              </ul>
                            </div>
                          </div>
                          <div className="d-flex flex-column gap-3">
                            <h4>Stress In The Workplace</h4>
                            <p>
                              We often perceive stress as having a negative
                              effect, but this isn't always true. In small
                              doses, stress can sharpen your focus and provide
                              the drive necessary to achieve your objectives.
                            </p>
                            <p>
                              However, excessive stress becomes detrimental to
                              both productivity and personal well-being.
                            </p>
                            <p>
                              Monitoring your stress levels is crucial.
                              Recognizing when they become overwhelming enables
                              you to take action and regain control.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {sect_8_1 && (
                    <div className="d-block fulw">
                      <img
                        src={require("../assets/ohs/images/pexels-photo-415471.jpg")}
                        alt="image"
                      />
                    </div>
                  )}
                  {sect_8_1 && (
                    <div className="col-lg-10 offset-md-1 col-lg-8 offset-lg-2">
                      <div
                        id=""
                        className="report d-flex flex-column gap-3 py-4"
                      >
                        <h4>Working at Heights</h4>
                        <p>
                          Working at heights refers to any workplace where a
                          person could fall from a height that might result in
                          injury if precautions aren't taken. This encompasses:
                        </p>

                        <ul className="d-flex flex-column gap-3 rep-ul">
                          <li>Working at ground level or below ground.</li>
                          <li>
                            Accessing or leaving such a location during work,
                            excluding staircases in permanent workplaces.
                          </li>
                        </ul>

                        <p>
                          Moreover, working at heights involves tasks performed
                          on elevated platforms like scaffolding, towers, or
                          mobile elevated work platforms (EWP). The regulations
                          define a working platform as follows:
                        </p>

                        <div className="img-block fulw">
                          <img
                            src={require("../assets/ohs/images/some4.jpg")}
                            alt="image"
                          />
                        </div>
                        <ul className="d-flex flex-column gap-3 rep-ul">
                          <li>
                            Any surface utilized for work or as a route to enter
                            or exit a work area.
                          </li>
                          <li>
                            Any structure such as scaffold, suspended scaffold,
                            cradle, mobile platform, trestle, gangway, or
                            gantry.
                          </li>
                        </ul>
                      </div>

                      <div
                        id="conti-btn"
                        onClick={btn_8}
                        className="d-flex py-4"
                      >
                        <button>CONTINUE</button>
                      </div>
                    </div>
                  )}
                  {sect_8 && (
                    <div className="col-lg-10 offset-md-1 col-lg-8 offset-lg-2">
                      <div
                        id=""
                        className="report d-flex flex-column gap-3 py-4"
                      >
                        <h4>Hazardous Manual Tasks (Manual Handling)</h4>
                        <p>
                          Manual handling typically involves the transportation
                          or support of a load (including lifting, lowering,
                          pushing, pulling, carrying, or moving) using hand or
                          bodily force.
                        </p>
                        <div className="d-block fulw">
                          <img
                            src={require("../assets/ohs/images/some5.jpg")}
                            alt="image"
                          />
                        </div>
                        <p>
                          A hazardous manual handling task is a task requiring a
                          person to lift, lower, push, pull, carry or otherwise
                          move, hold or restrain any person, animal or thing
                          involving one or more of the following:
                        </p>
                        <ul className="d-flex flex-column gap-3 rep-ul">
                          <li>Repetitive or sustained force.</li>
                          <li>High or sudden force.</li>
                          <li>Repetitive movement.</li>
                          <li>Sustained or awkward posture.</li>
                          <li>Exposure to vibration.</li>
                        </ul>
                      </div>

                      <div
                        id="conti-btn"
                        onClick={btn_8_2}
                        className="d-flex py-4"
                      >
                        <button>CONTINUE</button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          )}
          {lesson9 && (
            <section id="assessment" className="human w-100">
              <div className="d-flex flex-column">
                <Link
                  to="#workplace"
                  onClick={() => lessonInstruction("8_8")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 8 - Some Common Workplace Hazards</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 9 of 9</h4>
                      <h1>Final Assessment</h1>
                      <div className="line" style={{ maxWidth: "100%" }}></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>

                  <div className="col-lg-10 offset-md-1 padding py-5">
                    {stq && (
                      <form action="javascript:void(0)" method="post">
                        <div className="d-flex flex-column gap-5 fullname-block text-center py-5">
                          <h4>
                            Please enter your FULL NAME before you continue:
                          </h4>
                          <div className="d-flex justify-content-center name-form">
                            <div className="d-flex gap-2">
                              <div className="flex-grow-1">
                                <input
                                  type="text"
                                  name="name"
                                  onInput={entername_9}
                                  id=""
                                  required
                                  ref={inputRef}
                                  placeholder="Type your name here..."
                                />
                              </div>
                              <div className="flex-shrink-0">
                                <button type="submit" onClick={btn_entername}>
                                  Continue
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    )}
                    {quiz_dia && (
                      <>
                        <ReactDialogBox
                          closeBox={() => closedia(sectbtn)}
                          modalWidth="35%"
                          headerBackgroundColor="red"
                          headerTextColor="white"
                          headerHeight="65"
                          closeButtonColor="white"
                          bodyBackgroundColor="white"
                          bodyTextColor="green"
                          bodyHeight="200px"
                          headerText={invalidAns}
                        >
                          <div
                            className="modal fade show d-flex align-items-center"
                            role="dialog"
                            style={{
                              marginTop: "30px",
                              border: "none",
                            }}
                          >
                            <div className="modal-content diamod">
                              <div className="modal-body">
                                <div
                                  style={{
                                    padding: "19px",
                                  }}
                                >
                                  <p>{questans}</p>
                                </div>
                                <div className="d-flex justify-content-end">
                                  <button
                                    type="button"
                                    className="quiz_cont"
                                    onClick={() => closedia(sectbtn)}
                                  >
                                    Continue
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ReactDialogBox>
                      </>
                    )}
                    {less_9_q_1 && (
                      <div className="d-flex flex-column py-5 fullname-block">
                        <h4>
                          What are the principle reasons for health and safety
                          in the workplace?
                        </h4>

                        <div className="d-flex flex-column mt-4 gap-4 name-form">
                          <h5>Please select the correct answer:</h5>
                          <div className="d-flex gap-3">
                            <div class="position-relative">
                              <input
                                type="radio"
                                id="Insurance_business_and_productivity"
                                name="q1"
                                value="Insurance_business_and_productivity"
                                checked={
                                  checkQ_9_1 ===
                                  "Insurance_business_and_productivity"
                                }
                                onChange={() =>
                                  startQuiz9_1(
                                    "Insurance_business_and_productivity"
                                  )
                                }
                              />
                            </div>

                            <label
                              className="form-check-label"
                              for="Insurance_business_and_productivity"
                            >
                              Insurance, business and productivity
                            </label>
                          </div>
                          <div className="d-flex gap-3">
                            <div class="position-relative">
                              <input
                                type="radio"
                                id="Insurance_legal_and_productivity"
                                name="q1"
                                value="Insurance_legal_and_productivity"
                                checked={
                                  checkQ_9_1 ===
                                  "Insurance_legal_and_productivity"
                                }
                                onChange={() =>
                                  startQuiz9_1(
                                    "Insurance_legal_and_productivity"
                                  )
                                }
                              />
                            </div>
                            <label
                              className="form-check-label"
                              for="Insurance_legal_and_productivity"
                            >
                              Insurance, legal and productivity
                            </label>
                          </div>
                          <div className="d-flex gap-3">
                            <div class="position-relative">
                              <input
                                type="radio"
                                id="Legal_moral_and_financial"
                                name="q1"
                                value="Legal_moral_and_financial"
                                checked={
                                  checkQ_9_1 === "Legal_moral_and_financial"
                                }
                                onChange={() =>
                                  startQuiz9_1("Legal_moral_and_financial")
                                }
                              />
                            </div>
                            <label
                              className="form-check-label"
                              for="Legal_moral_and_financial"
                            >
                              Legal, moral and financial
                            </label>
                          </div>
                          <div className="d-flex gap-3">
                            <input
                              type="radio"
                              id="Legal_moral_and_insurance"
                              name="q1"
                              value="Legal_moral_and_insurance"
                              checked={
                                checkQ_9_1 === "Legal_moral_and_insurance"
                              }
                              onChange={() =>
                                startQuiz9_1("Legal_moral_and_insurance")
                              }
                            />

                            <label
                              className="form-check-label"
                              for="Legal_moral_and_insurance"
                            >
                              Legal, moral and insurance
                            </label>
                          </div>
                          <div className="d-flex justify-content-end">
                            <button
                              type="button"
                              onClick={() => quiz1_checkbtn("1")}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    {less_9_q_2 && (
                      <div className="d-flex flex-column py-5 fullname-block">
                        <h4>
                          What is the biggest cause of workplace fatalities in
                          Australia?
                        </h4>

                        <div className="d-flex flex-column mt-4 gap-4 name-form">
                          <h5>Please select the correct answer:</h5>
                          <div className="d-flex gap-3">
                            <input
                              type="radio"
                              id="Vehicle_collisions"
                              name="q1"
                              value="Vehicle_collisions"
                              checked={checkQ_9_2 === "Vehicle_collisions"}
                              onChange={() =>
                                startQuiz9_2("Vehicle_collisions")
                              }
                            />
                            <label
                              className="form-check-label"
                              for="Vehicle_collisions"
                            >
                              Vehicle collisions
                            </label>
                          </div>
                          <div className="d-flex gap-3">
                            <input
                              type="radio"
                              id="Overheating"
                              name="q1"
                              value="Overheating"
                              checked={checkQ_9_2 === "Overheating"}
                              onChange={() => startQuiz9_2("Overheating")}
                            />
                            <label
                              className="form-check-label"
                              for="Overheating"
                            >
                              Overheating
                            </label>
                          </div>
                          <div className="d-flex gap-3">
                            <input
                              type="radio"
                              id="Strike_by_a_falling"
                              name="q1"
                              value="Strike_by_a_falling"
                              checked={checkQ_9_2 === "Strike_by_a_falling"}
                              onChange={() =>
                                startQuiz9_2("Strike_by_a_falling")
                              }
                            />
                            <label
                              className="form-check-label"
                              for="Strike_by_a_falling"
                            >
                              Strike by a falling object
                            </label>
                          </div>
                          <div className="d-flex gap-3">
                            <input
                              type="radio"
                              id="Strike_by_a_vehicle"
                              name="q1"
                              value="Strike_by_a_vehicle"
                              checked={checkQ_9_2 === "Strike_by_a_vehicle"}
                              onChange={() =>
                                startQuiz9_2("Strike_by_a_vehicle")
                              }
                            />
                            <label
                              className="form-check-label"
                              for="Strike_by_a_vehicle"
                            >
                              Strike by a moving vehicle
                            </label>
                          </div>
                          <div className="d-flex justify-content-end">
                            <button
                              type="button"
                              onClick={() => quiz1_checkbtn("2")}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    {less_9_q_3 && (
                      <div className="d-flex flex-column py-5 fullname-block">
                        <h4>What are common workplace hazards?</h4>

                        <div className="d-flex flex-column mt-4 gap-4 name-form">
                          <h5>Please select the correct answer:</h5>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="fl1"
                            />
                            <label className="form-check-label" for="fl1">
                              Slips, trips and falls
                            </label>
                          </div>
                          <div className="d-flex gap-3">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Working_at_heights"
                              checked={checkQ_9_3 === "Working_at_heights"}
                              onChange={() =>
                                startQuiz9_3("Working_at_heights")
                              }
                            />
                            <label
                              className="form-check-label"
                              for="Working_at_heights"
                            >
                              Working at heights
                            </label>
                          </div>
                          <div className="d-flex gap-3">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Stress_in_the_workplace"
                              checked={checkQ_9_3 === "Stress_in_the_workplace"}
                              onChange={() =>
                                startQuiz9_3("Stress_in_the_workplace")
                              }
                            />
                            <label
                              className="form-check-label"
                              for="Stress_in_the_workplace"
                            >
                              Stress in the workplace
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="All_of_the_above"
                              checked={checkQ_9_3 === "All_of_the_above"}
                              onChange={() => startQuiz9_3("All_of_the_above")}
                            />
                            <label
                              className="form-check-label"
                              for="All_of_the_above"
                            >
                              All of the above
                            </label>
                          </div>
                          <div className="d-flex justify-content-end">
                            <button
                              type="button"
                              onClick={() => quiz1_checkbtn("3")}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    {less_9_q_4 && (
                      <div className="d-flex flex-column py-5 fullname-block">
                        <h4>
                          What do health and safety inspectors have the power to
                          do?
                        </h4>

                        <div className="d-flex flex-column mt-4 gap-4 name-form">
                          <h5>Please select the correct answer:</h5>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Issue_improvement_notices"
                              checked={
                                checkQ_9_4 === "Issue_improvement_notices"
                              }
                              onChange={() =>
                                startQuiz9_4("Issue_improvement_notices")
                              }
                            />
                            <label
                              className="form-check-label"
                              for="Issue_improvement_notices"
                            >
                              Issue improvement notices
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Issue_prohibition_notices"
                              checked={
                                checkQ_9_4 === "Issue_prohibition_notices"
                              }
                              onChange={() =>
                                startQuiz9_4("Issue_prohibition_notices")
                              }
                            />
                            <label
                              className="form-check-label"
                              for="Issue_prohibition_notices"
                            >
                              Issue prohibition notices
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Issue_prohibition_procedures"
                              checked={
                                checkQ_9_4 === "Issue_prohibition_procedures"
                              }
                              onChange={() =>
                                startQuiz9_4("Issue_prohibition_procedures")
                              }
                            />
                            <label
                              className="form-check-label"
                              for="Issue_prohibition_procedures"
                            >
                              Initiate prosecution procedures
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="All_of_the_above"
                              checked={checkQ_9_4 === "All_of_the_above"}
                              onChange={() => startQuiz9_4("All_of_the_above")}
                            />
                            <label
                              className="form-check-label"
                              for="All_of_the_above"
                            >
                              All of the above
                            </label>
                          </div>
                          <div className="d-flex justify-content-end">
                            <button
                              type="button"
                              onClick={() => quiz1_checkbtn("4")}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    {less_9_q_5 && (
                      <div className="d-flex flex-column py-5 fullname-block">
                        <h4>
                          Who is responsible for health and safety within the
                          workplace?
                        </h4>

                        <div className="d-flex flex-column mt-4 gap-4 name-form">
                          <h5>Please select the correct answer:</h5>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Line_manager"
                              checked={checkQ_9_5 === "Line_manager"}
                              onChange={() => startQuiz9_5("Line_manager")}
                            />
                            <label
                              className="form-check-label"
                              for="Line_manager"
                            >
                              Line manager
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Company_director"
                              checked={checkQ_9_5 === "Company_director"}
                              onChange={() => startQuiz9_5("Company_director")}
                            />
                            <label
                              className="form-check-label"
                              for="Company_director"
                            >
                              Company director
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Everyone"
                              checked={checkQ_9_5 === "Everyone"}
                              onChange={() => startQuiz9_5("Everyone")}
                            />
                            <label className="form-check-label" for="Everyone">
                              Everyone
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Health_and_safety_manager"
                              checked={
                                checkQ_9_5 === "Health_and_safety_manager"
                              }
                              onChange={() =>
                                startQuiz9_5("Health_and_safety_manager")
                              }
                            />
                            <label
                              className="form-check-label"
                              for="Health_and_safety_manager"
                            >
                              Health and safety manager
                            </label>
                          </div>
                          <div className="d-flex justify-content-end">
                            <button
                              type="button"
                              onClick={() => quiz1_checkbtn("5")}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {less_9_result && (
                      <div className="d-flex flex-column gap-3 text-center results-block">
                        <h3 className="text-danger">Results</h3>

                        <div className="row gy-3 gy-md-5">
                          <div className="col-lg-6">
                            <h3>
                              <b>Your Score:</b>
                            </h3>
                          </div>
                          <div className="col-lg-6">
                            <h3>
                              {score}% ({score_s} points)
                            </h3>
                          </div>
                          <div className="col-lg-6">
                            <h3>
                              <b>Passing Score:</b>
                            </h3>
                          </div>
                          <div className="col-lg-6">
                            <h3>80% (40 points)</h3>
                          </div>
                          <div className="col-12">
                            {!corrScore && (
                              <h4 className="text-danger">
                                <i className="far fa-times"></i> You did not
                                pass
                              </h4>
                            )}
                            {corrScore && (
                              <h4 className="text-success">
                                <i className="far fa-check"></i> You pass
                              </h4>
                            )}
                          </div>
                          {score >= 80 ? (
                            <div className="col-lg-">
                              <button
                                type="button"
                                onClick={() => downloadpdf()}
                              >
                                Download
                              </button>
                            </div>
                          ) : (
                            <div className="col-lg-">
                              <button type="button" onClick={retryButton}>
                                Retry Assessment
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    </>
  );
};
